const TAGS = {
	NEW: 'new',
	PREORDER: 'Pre-order',
	COMING_SOON: 'Coming soon',
	RESPONSIBLE: 'Responsible',
	EXCLUSIVE_PRICE: 'Exclusive price',
	ONLINE_ONLY: 'Online only',
	INSTORE: 'instore',
	OUT_OF_STOCK: 'Out of stock',
	GI: 'GI'
};

/**
 * GDPR. Add overflow to body on open modal
 */
$(document).on('click touchstart', '.cc-settings', function() {
	$("body").css("overflow","hidden");

	var selectors = {
		acceptSelected: '.cc-btn-accept-selected',
		acceptAll: '.cc-btn-accept-all',
		closeSettings: '.cc-btn-close-settings'
	};

	$(selectors.acceptSelected).on('click', removeBodyOverflow);
	$(selectors.acceptAll).on('click', removeBodyOverflow);
	$(selectors.closeSettings).on('click', removeBodyOverflow);
});

function removeBodyOverflow(evt) {
	evt.preventDefault();

	if($("body").is('[style]')) {
		$("body").css("overflow","unset");
	}
}

const emailRegex = /^\w+([\.-]?)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

if(typeof pn === "undefined"){
	pn = {};
}
if(typeof pn.settings === "undefined"){
	pn.settings = {};
}
pn.settings.defaultSetting={"id":14991813,"a":"Pre-order Now","b":true,"c":null,"d":"Out of stock","e":false,"f":"Only  remaining","g":"","h":"below","i":false,"j":null,"k":null,"l":null,"m":"default","n":null,"o":true,"handle":null,"p":null,"y":null,"q":false,"r":true,"s":null,"t":null,"u":1,"v":false,"w":"ribbon","tag":null,"x":null,"z":"no_discount","aa":"0.0","ab":0,"price":"0.0","compare_at_price":"0.0"};
pn.settings.singleProductSettings=[];
pn.settings.tagSettings=[];

if (typeof productMetafields === 'undefined') {
	var productMetafields = {}
}

Handlebars.registerHelper('ifArrayHasNotEmptyProduct', function (array, options) {
	const size = array ? array.filter(value => value.url).length : 0;
	return size > 0 ?  options.fn(this) : '';
});

Handlebars.registerHelper('ifProductIsActive', function (product, options) {
	return !product.hasOwnProperty('status') || (product.hasOwnProperty('status') && product.status === 'ACTIVE') ?  options.fn(this) : '';
});

Handlebars.registerHelper('ifEqualsProduct', function(arg1, arg2, arg3, options) {
	return (arg1.colorHex === arg2) && (arg1.handle === arg3) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifProduct', function (product, options) {
	return product.url ?  options.fn(this) : '';
});

Handlebars.registerHelper('times', function(n, block) {
	let accum = '';
	for(let i = 0; i < n; ++i)
		accum += block.fn(i);
	return accum;
});

// Detect touch devices
var Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
	touchDevice = true;
  }

  function isTouch() {
	return touchDevice;
  }
  return {
	setTouch: setTouch,
	isTouch: isTouch
  };
})();

// Library loader for 3D Model and Plyr video player
var LibraryLoader = (function() {
  var types = {
	link: 'link',
	script: 'script'
  };

  var status = {
	requested: 'requested',
	loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
	youtubeSdk: {
	  tagId: 'youtube-sdk',
	  src: 'https://www.youtube.com/iframe_api',
	  type: types.script
	},
	plyrShopifyStyles: {
	  tagId: 'plyr-shopify-styles',
	  src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
	  type: types.link
	},
	modelViewerUiStyles: {
	  tagId: 'shopify-model-viewer-ui-styles',
	  src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
	  type: types.link
	}
  };

  function load(libraryName, callback) {
	var library = libraries[libraryName];

	if (!library) return;
	if (library.status === status.requested) return;

	callback = callback || function() {};
	if (library.status === status.loaded) {
	  callback();
	  return;
	}

	library.status = status.requested;

	var tag;

	switch (library.type) {
	  case types.script:
		tag = createScriptTag(library, callback);
		break;
	  case types.link:
		tag = createLinkTag(library, callback);
		break;
	}

	tag.id = library.tagId;
	library.element = tag;

	var firstScriptTag = document.getElementsByTagName(library.type)[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
	var tag = document.createElement('script');
	tag.src = library.src;
	tag.addEventListener('load', function() {
	  library.status = status.loaded;
	  callback();
	});
	return tag;
  }

  function createLinkTag(library, callback) {
	var tag = document.createElement('link');
	tag.href = library.src;
	tag.rel = 'stylesheet';
	tag.type = 'text/css';
	tag.addEventListener('load', function() {
	  library.status = status.loaded;
	  callback();
	});
	return tag;
  }

  return {
	load: load
  };
})();


jQuery( function ($) {
	var Sections = {
		init: function() {
			$( document )
				.on( 'shopify:section:load', this._onSectionLoad )
				.on( 'shopify:section:unload', this._onSectionUnload )
				.on( 'shopify:section:select', this._onSectionSelect )
				.on( 'shopify:section:deselect', this._onSectionDeselect )
				.on( 'shopify:block:select', this._onBlockSelect )
				.on( 'shopify:block:deselect', this._onBlockDeselect );
		},

		/**
		 * A section has been deleted or is being re-rendered.
		 */
		_onSectionUnload: function( e ) {
			var section = e.target.children[ 0 ].getAttribute( 'data-section-type' ) || false;

			switch( section ) {
				case 'gallery':
					_unloadGallery( e.target );
					break;
				case 'slideshow':
					_unloadHero( e.target );
					break;
				case 'logos-list':
					_unloadLogosList( e.target );
					break;
				case 'mosaic':
					_unloadMosaic( e.target );
					break;
				case 'testimonials':
					_unloadTestimonials( e.target );
					break;
				case 'popup':
					_unloadPopup( e.target );
					break;
				case 'product':
					_unloadProduct( e.target );
					break;
				case 'collection-template':
					_unloadProductGrid( e.target );
					break;
				case 'featured-collection':
					_unloadProductGrid( e.target );
					break;
				case 'related-products':
					_unloadProductGrid( e.target );
					break;
			}

			function _unloadGallery( t ) {
				var slider = $( t ).find( '.js-slider' );

				slider.slick( 'unslick' );

				$(window).off( 'scroll.gallery' );
			}

			function _unloadHero( t ) {
				var hero = $( t ).find( '.js-hero-slider' );

				hero.slick( 'unslick' );

				Site.header.resetHeader();
				Site.header.setHeaderPosition();
				Site.header.init();

				// Trigger scroll to change the header style
				setTimeout( function() {
					$(window).trigger( 'scroll');
				}, 100);
				$(window).off( 'scroll.slideshow resize.slideshow' );
			}

			function _unloadLogosList( t ) {
				var slider = $( t ).find( '.js-logos-slider' );

				slider.slick( 'unslick' );
			}

			function _unloadMosaic( t ) {
				var slider = $( t ).find( '.js-mosaic__blocks' );
				var isSlickActive = slider.hasClass('slick-initialized');

				if ( isSlickActive ) {
					slider.slick( 'unslick' );
				}
				$(window).off( 'resize.mosaic' );
			}

			function _unloadTestimonials( t ) {
				var slider = $( t ).find( '.js-testimonials__blocks' );

				slider.slick( 'unslick' );
			}

			function _unloadPopup( t ) {
				Popup.hide();
				$('.jquery-modal').add('#popup').remove();
			}

			function _unloadProduct( t ) {
				var sectionId = $( t ).children().first().data( 'section-id' );

				ProductVideo.removeSectionVideos( sectionId );

				$(window).off( 'resize.product' );
				$(window).off( 'scroll.product' );
			}

			function _unloadProductGrid( t ) {
				var sectionId = $( t ).children().first().data( 'section-id' );

				$(window).off( 'resize.products' );
			}

		},

		/**
		 * User has selected the section in the sidebar.
		 */
		_onSectionSelect: function( e ) {
			var section = e.target.children[ 0 ].getAttribute( 'data-section-type' ) || e.target.children[ 1 ].getAttribute( 'data-section-type' ) || e.target.children[ 2 ].getAttribute( 'data-section-type' ) || false;

			switch( section ) {
				case 'header':
					_selectHeader( e.target );
					break;
				case 'popup':
					_selectPopup( e.target );
					break;
			}

			function _selectHeader( t ) {
				Site.header.resetHeader();
				Site.header.setHeaderPosition();
				Site.nav.hide();
				Site.header.init();
			}

			function _selectPopup( t ) {
				Popup.init();
			}
		},

		/**
		 * User has selected the section in the sidebar.
		 */
		_onSectionDeselect: function( e ) {
			var section = e.target.children[ 0 ].getAttribute( 'data-section-type' ) || false;

			switch( section ) {
				case 'header':
					_deselectHeader( e.target );
					break;
			}

			function _deselectHeader( t ) {
				Site.nav.hide();
			}

		},

		/**
		 * User has selected the block in the sidebar.
		 */
		_onBlockSelect: function( e ) {
			var block = e.target.getAttribute( 'data-block' ) || false;

			switch( block ) {
				case 'slide':
					_selectBlockSlide( e.target );
					break;
				case 'banner':
					_selectBlockBanner( e.target );
					break;
				case 'mosaic':
					_selectBlockMosaic( e.target );
					break;
				case 'testimonial':
					_selectBlockTestimonial( e.target );
					break;
				case 'item_logo':
					_selectBlockItemLogo( e.target );
					break;
			}

			function _selectBlockSlide( t ) {
				var slider, index;

				slider = $( t ).parents( '.slick-slider' );
				index = $( t ).parents('.slick-slide:not(.slick-cloned)').attr( 'data-slick-index' );

				slider.addClass( 'no-transition' );
				slider.slick( 'slickGoTo', index );
				slider.slick( 'slickPause' );
			}

			function _selectBlockBanner( t ) {
			}

			function _selectBlockMosaic( t ) {
				var slider = $( t ).parents( '.js-mosaic__blocks' ),
					isSlickActive = slider.hasClass('slick-initialized'),
					index;

				if (isSlickActive) {
					index = $( t ).parents('.slick-slide:not(.slick-cloned)').attr( 'data-slick-index' );

					slider.addClass('no-transition')
					slider.slick( 'slickGoTo', index );
					slider.slick( 'slickPause' );
				}

				Site.onPriceAdded();
			}

			function _selectBlockTestimonial( t ) {
				var slider = $( t ).parents( '.js-testimonials__blocks' ),
					isSlickActive = slider.hasClass('slick-initialized'),
					index;

				if (isSlickActive) {
					index = $( t ).parents('.slick-slide:not(.slick-cloned)').attr( 'data-slick-index' );

					slider.slick( 'slickGoTo', index );
					slider.slick( 'slickPause' );
				}
			}

			function _selectBlockItemLogo( t ) {
				var slider = $( t ).parents( '.js-logos-slider' ),
					index = $( t ).parents('.slick-slide:not(.slick-cloned)').attr( 'data-slick-index' );

				slider.slick( 'slickGoTo', index );
			}
		},

		/**
		 * User has DEselected the block in the sidebar.
		 */
		_onBlockDeselect: function( e ) {
			var block = e.target.getAttribute( 'data-block' ) || false;

			switch( block ) {
				case 'slide':
					_deselectBlockSlide( e.target );
					break;
				case 'item_logo':
					_deselectBlockItemLogo( e.target );
					break;
			}

			function _deselectBlockSlide( t ) {
				var slider = $( t ).parents( '.slick-slider' ),
					options = JSON.parse( slider.data( 'slick' ).replace(/'/g, '"') );

				slider.removeClass('no-transition');

				if ( options.autoplay ) {
					slider.slick('slickPlay');
				}
			}

			function _deselectBlockItemLogo( t ) {
				var slider = $( t ).parents( '.js-logos-slider' );
				slider.slick('slickPlay');
			}
		}
	}

	var s;
	window.Site = {
		settings: {
			b: $('body'),
			w: $(window),
			d: $(document)
		},

		init: function(){
			s = this.settings;

			this.general();
			this.animations.init();
			this.header.init();
			this.footer();
			this.nav.init();
			this.sliders.init();
			this.addresses.init();
			this.keyboardAccessible();
			this.video();
			this.faq();
			this.checkReviewsApp();

			if ($('.js-siteAlert').length){
				this.promo.init();
			}

			if (this.getQueryParameter('customer_posted') == "true") {
				$('body').addClass('signUp-posted');
				s.d.scrollTop( s.d.height() - s.w.height() );
			}


          $('.button--append').on( 'click', function() {
            var $cellElems = $( makeCellHtml() + makeCellHtml() );
            $carousel.flickity( 'append', $cellElems );
          });

          var cellCount = 3;

          function makeCellHtml() {
            cellCount++;
            return '<div class="carousel-cell">' + cellCount + '</div>';
          }
// TODO: delete test code

		},

		/*
		 * General Bindings
		 */
		general: function(){

			// Social sharing links
			s.b.on('click', '.share-link', function(event) {

				event.preventDefault();

				var el = $(this),
					popup = el.attr('data-network'),
					link = el.attr('href'),
					w = 700,
					h = 400;

				switch (popup) {
					case 'twitter':
						h = 300;
						break;
				}

				window.open(link, popup, 'width=' + w + ', height=' + h);

			});

			s.spinner = $('#Spinner').html();

		},

		getQueryParameter: function(name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				results = regex.exec(location.search);
			return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
		},

		keyboardAccessible: function(){
			s.w.mousedown(function(event) {
				s.b.addClass("no-outline");
			});
			s.w.keyup(function(event) {
				if ( event.keyCode === 9 ) {
					s.b.removeClass("no-outline");
				}
			});
		},

		/*
		 * Header Scroll Function
		 */
		header: {
			init: function() {
				var $header = $('.header'),
					scroll = 0,
					heroEnabled = $('.main-content').children().first( '.shopify-section' ).hasClass( 'header--full' ) || $('.main-content').children().first( '.shopify-section' ).find( '[data-header-style="index"]').length,
					alertHeight = $('.siteAlert').outerHeight() || 0,
              		hideBG = $header.hasClass( 'hide_header_no_bg' );


				$(window)
					.on( 'resize', Reqs.debounce( checkNavigationOverlapping, 10) )
					.on( 'resize', Reqs.throttle( Site.setCartClosePosition, 10) )
					.on( 'scroll', Reqs.throttle( setHeaderState, 10) );

				setTimeout(checkNavigationOverlapping, 50);

				initPadding();

				$(document).on( 'shopify:section:reorder', initPadding );
				$(document).on( 'shopify:section:reorder', checkNavigationOverlapping );

				function setHeaderState() {
					if (!$('.template-index').length) {
                      	$header.removeClass('hide_header_no_bg');
						scroll = $(window).scrollTop();

						if (scroll > alertHeight) {
							$header.addClass('has-scrolled');
						} else {
							$header.removeClass('has-scrolled');
						}
					} else {
						/* Desktop with hero enabled (wait until after hero to transition header) */
						scroll = $(window).scrollTop();
						heroEnabled = $('.main-content').children().first( '.shopify-section' ).hasClass( 'header--full' ) || $('.main-content').children().first( '.shopify-section' ).find( '[data-header-style="index"]').length;

						if (heroEnabled) {
                          if(!hideBG) {
                          	if (scroll > alertHeight) {
								$header.addClass('has-scrolled')
							} else {
								$header.removeClass('has-scrolled')
							}
                          }
                          else {
                            $header.addClass('has-scrolled');
                          }
						}
                      	else {
							if (scroll > -1) {
								$header.addClass('has-scrolled');
							} else {
								$header.removeClass('has-scrolled');
							}
						}
					}
				}

				function initPadding() {
					var isHomePage = $('body').hasClass('template-index');
					if ( isHomePage ) {
						var firstSectionParent = $('.main-content').children(':first');
						var heroEnabled = $('.main-content').children().first( '.shopify-section' ).hasClass( 'header--full' );
						if ( !$(firstSectionParent).hasClass('header--full') || heroEnabled == false ){
							$('.bodyWrap').addClass('mo-padding');
						} else {
							$('.bodyWrap').removeClass('mo-padding');
						}
					}
				}

				function checkNavigationOverlapping() {
					var isNavigationOverlapping = getNavigationOverlapping();
					var isDesktop = $(window).width() >= 1024;

					if ( isNavigationOverlapping || !isDesktop ) {
					} else {
						Site.nav.hide();
					}

					setHeaderState();
				}

				function getNavigationOverlapping() {
					$('.header').removeClass('has-scrolled');

					var headerContainerWidth = $('.header .container > .row').width();
					var navMenuWidth = getMenuItemsWidth();
					var isNavigationOverlapping = false;
					var isNavLeftLogoCentered = $('.header').hasClass('header--logo_center_links_left') || $('.header').hasClass('header--logo_left_links_left');
					var additionalSpace = 40; // Additional spacing from margins
					var headerIconsWidth = $('.header__icons').outerWidth();
					var logoWidth = $('.main-logo__image').length ? $('.main-logo__image').data( 'width' ) : 0;
					logoWidth += $( '.main-logo__text' ).outerWidth();

					isNavigationOverlapping = parseInt( headerContainerWidth ) < parseInt( navMenuWidth + logoWidth + headerIconsWidth + additionalSpace );

					if ( isNavLeftLogoCentered ) {
						isNavigationOverlapping = parseInt( ( headerContainerWidth - logoWidth ) / 2 ) < parseInt( navMenuWidth );
					}

					return isNavigationOverlapping;
				}

				function getMenuItemsWidth() {
					var itemsWidth = 0;
					$('.nav-standard .menu > li').each(function() {
						itemsWidth += $(this).outerWidth(true);
					});
					return itemsWidth;
				}
			},

			resetHeader: function() {
				var page = $( 'body, html' );
				var content = $( '.bodyWrap' );
				var $hamburger = $( '#hamburger-menu' );
				var $transformElements = $( '.header, .siteAlert, .bodyWrap' );

				page.removeClass( 'nav--is-visible' );
				content.removeAttr( 'style' );
				$transformElements.css( 'transform', 'none' );
				$hamburger.removeClass( 'open' );

				if ( $( 'body' ).hasClass( 'cart--is-visible' ) ) {
					$( '.js-cartToggle' ).click();
				}
			},

			setHeaderPosition: function() {
				var promo = $('.js-siteAlert');
				var promoHeight = promo.outerHeight();
				var header = $( '.header' );

				if ( promo.length ){
					header.addClass( 'alert--is-visible shift--alert' );

					$( window ).on('scroll', function(){
						( $( window ).scrollTop() >= promoHeight ) ? header.removeClass( 'shift--alert' ) : header.addClass( 'shift--alert' );
					});
				}
			}
		},

		setCartClosePosition: function() {
			if ( $('#cartTotal').length ) {
				var cartBtnOffsetTop = $('#cartTotal').offset().top;
				var cartBtnClose = $('.cartContainer .js-cartToggle');
				var scrolled = $(window).scrollTop();
				var containerPadding = 0; //40
				var cartBtnTop = cartBtnOffsetTop - containerPadding - scrolled;

				cartBtnClose.css({
					'top': cartBtnTop
				});
			}
		},

		footer: function() {
			var $shopBar = $('#add-to-cart-bar');
			var $productContainer = $( '.js-product-template' );
			var $siteFooter = $( '.site-footer' );

			$(window).on('scroll',
				Reqs.throttle( function(){
					var scrolled = $(window).scrollTop();

					if ( $productContainer.length && $shopBar.length ) {
						var productContainerOffset = $productContainer.offset().top;

						if ( scrolled > productContainerOffset ) {
							$shopBar.addClass('product-bar--is-visible');
							$siteFooter.addClass('site-footer--push')
						} else if ( scrolled < productContainerOffset - 60 ) {
							$shopBar.removeClass('product-bar--is-visible');
							$siteFooter.removeClass('site-footer--push')
						}
					}
				}, 100)
			);
		},

		promo: {
			alert: $('.js-siteAlert'),
			header: $('.header'),
			promo_inner: $('.js-siteAlert .block'),

			init: function(){
				var alert = this.alert,
					promo_inner = this.promo_inner,
					content = alert.html();
					Site.promo.updateHeader();

				$('.js-alert-close').on('click', function(){
					alert.removeClass('no-transition');
					setTimeout(function(){
						Site.promo.hide();
					}, 500);
				});

				function _updateHeight() {
					var height = promo_inner.innerHeight();
					alert.css('height', height);
				}

				function _setCookie(cname, cvalue, exdays) {
					var d = new Date();
					d.setTime(d.getTime() + (exdays*24*60*60*1000));
					var expires = "expires="+d.toUTCString();
					document.cookie = cname + "=" + cvalue + "; " + expires;
				}

				function _getCookie(cname) {
					var name = cname + "=";
					var ca = document.cookie.split(';');
					for(var i=0; i<ca.length; i++) {
						var c = ca[i];
						while (c.charAt(0)==' ') c = c.substring(1);
						if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
					}
					return "";
				}

				function _checkCookie() {
					var user = getCookie("username");
					if (user != "") {
						alert("Welcome again " + user);
					} else {
						user = prompt("Please enter your name:", "");
						if (user != "" && user != null) {
							setCookie("username", user, 365);
						}
					}
				}
			},
			show: function(){
				var alert = this.alert,
					promo_inner = alert.find('.block'),
					height = promo_inner.innerHeight();

				alert.css({'height': height});

				Site.promo.updateHeader();

				$(window).resize(
					Reqs.throttle( function(){
						var height = promo_inner.innerHeight();

						alert.css({'height': height});
					}, 500)
				);
			},
			hide: function(){
				var alert = this.alert,
					content = alert.html();

					alert.css({'height': 0});
				setTimeout(function(){
					alert.remove();
				}, 500);
			},
			updateHeader: function(){
				var alert = this.alert,
					height = alert.outerHeight(),
					header = this.header;

				header.addClass('alert--is-visible');

				header.addClass('shift--alert');

				$(window).on('scroll', Reqs.throttle(function(){
					var height = alert.outerHeight();

					if ($(window).scrollTop() >= height) {
						header.removeClass('shift--alert');
					} else {
						header.addClass('shift--alert');
					}
				}, 50));
			}
		},

		video: function(){
			var self = this;

			Reqs.lightbox();
			$('.js-video').each( function() {
				var container = $(this).closest( '.video-module' );
				var isImageHeight = $(container).data( 'height' ) == 'original-height';

				if ( isImageHeight ) {
					self.setVideoHeight( container );
					$(window).on( 'resize', Reqs.debounce( function() {
						self.setVideoHeight( container );
					}, 250));
					$( container ).on( 'lazybeforeunveil', self.setVideoHeight( container ) );
				}

				$(this).magnificPopup({
					closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-close"></button>',
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
					fixedContentPos: false,
					iframe: {
					  markup: '<div class="mfp-iframe-scaler">'+
								'<div class="mfp-close"></div>'+
								'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
							  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

					  patterns: {
						youtube: {
						  index: 'youtube.com/',
						  id: 'v=',
						  src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0modestbranding=0' // URL that will be set as a source for iframe.
						},
					  },
					  srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
					}
				});
			});
		},

		setVideoHeight: function( container ) {
			var contentHeight = $(container).find( '.video-text__content' ).outerHeight();
			var $videoContainer = $(container).find( '.video-container > img, .video-placeholder, .placeholder-svg' );

			$videoContainer.css( 'min-height', contentHeight )
		},

		faq: function(){
			$('.faq-list__item-question', document).on('click', function() {
				$(this).parent().toggleClass('is-expanded');
			});
		},

		/*
		 * Sliders
		 */
		sliders: {
			init: function(){
				this.hero();
				this.collection();
				this.gallery();
				this.mosaic();
				this.testimonials();
				this.logosList();
			},

			/* Homepage Hero Slider */
			hero: function(){
				var self = this;
				var hero = $( '.js-hero-slider' );
				var options = {};
				var scrollDownBtn = $('.js-scroll-down');

				hero.each( function () {
					var currentHero = $(this),
						options = JSON.parse( currentHero.data( 'slick' ).replace(/'/g, '"') );

					currentHero.on('init', function() {
						var currentStyle = $(this).find('.js-slide[data-slick-index="1"]').data('style');
						$(this).attr('data-current-style', currentStyle);
						$(this).removeClass('hero--is-loading');
					});

					currentHero.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
						var activeSlide = parseInt(nextSlide + 1);
						var $nextSlide = $(this).find('.js-slide[data-slick-index="' + activeSlide +'"]');
						var currentStyle = $nextSlide.data('style');

						$(this).attr('data-current-style', currentStyle);

						if ( !$nextSlide.find( '.fade-in' ).hasClass( 'lazyloaded' ) ) {
							$nextSlide.find( '.fade-in' ).addClass( 'lazyload' );
						}
					});

					currentHero.slick( options );

					$(window).on( 'scroll.slideshow resize.slideshow', Reqs.throttle( function() {
						var windowHeight = $(window).height();
						var windowScroll = $(window).scrollTop();
						var heroHeight = currentHero.height();
						var heroOffsetTop = currentHero.offset().top;

						// If Hero is outside the the viewport pause slideshow
						if ( heroOffsetTop + heroHeight >= windowScroll && heroOffsetTop - windowHeight <= windowScroll && options.autoplay ) {
							currentHero.slick( 'slickPlay' );
						} else {
							currentHero.slick( 'slickPause' );
						}
					}, 10));
				} );

				$('.slick-list').attr('tabindex','-1');

				scrollDownBtn.on('click', function(e) {
					e.preventDefault();

					var isStandardNav = $(window).width() >= 768 && $('.header').hasClass('is-standard');
					var headerHeight = isStandardNav ? 59 : -1;
					var scrollToPosition = parseInt(hero.offset().top + hero.outerHeight() - headerHeight);
					$('html, body').stop(true, false).animate({ 'scrollTop': scrollToPosition }, 500);
				});
			},

			/* Collection Slider */
			collection: function(){
				var $container = $( '.js-collection-grid' );
				var $carousel = $( '.js-collection-slider' );

				$carousel.find('.will-animate').removeClass('will-animate');

				$('.quickView-button', $carousel).on('click', function() {
					$(this).closest('.slick-slide').addClass('slick-slide--quickView');
				});

				$('html, body').on('quickView:show', function() {
					setQuickViewPosition();
					$carousel.find('.slick-slide--quickView').removeClass('slick-slide--quickView');
				});

				$('html, body').on('quickView:ajax', setQuickViewPosition);

				$container.each(function() {
					Site.sliders.setCarouselState( $(this) );
				});

				$(window).on( 'resize', Reqs.debounce(function() {
					setQuickViewPosition();

					$container.each(function() {
						Site.sliders.setCarouselState( $(this) );
					});
				}, 250));

				function setQuickViewPosition() {
					var $slide = $carousel.find('.slick-slide--quickView');

					if ( !$slide.length ) {
						$slide = $carousel.find('.quickView--is-visible').closest('.slick-slide');
					}

					if ( $carousel.length && $slide.length ) {
						var $quickView = $slide.find('.quickView-wrap');
						var offsetLeft = $carousel.find('.slick-slide.slick-current').position().left - $slide.position().left;

						$quickView.css('left', offsetLeft);
					}
				}
			},

			setCarouselState: function($container) {
				let mobileSlider = null
				if ( typeof($container) == 'undefined' ) return;

				var $carousel = $container.find( '.js-collection-slider' );

				$carousel.find('.will-animate').removeClass('will-animate');

				$carousel.on( 'init', function() {
					setArrowsPosition();
				} );


				if ( $carousel.length ) {
					var isDesktopInitialized = $carousel.hasClass( 'slick-initialized' );
					var isMobileInitialized = $carousel.hasClass('flickity-enabled');
					var slidesPerRow = parseInt( $container.data( 'slides-per-row' ));
					var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

					if ( windowWidth >= 768 ) {
						// Destroy mobile carousel if initialized
						if ( isMobileInitialized ) {

							// Give time for the mobile slider to be destroyed
							setTimeout( initDesktopCarousel, 100);
						} else {
							initDesktopCarousel();
						}
					} else {
						// Destroy desktop carousel if initialized
						if ( isDesktopInitialized ) {
							$carousel.slick( 'unslick' );

							// Give time for the desktop slider to be destroyed
							setTimeout(mobileSlider = initMobileCarousel, 100);
						} else {
							mobileSlider = initMobileCarousel();
						}
					}
				}

				function initDesktopCarousel() {
					if ( !isDesktopInitialized ) {
                        if ($container.data().dynamicProducts === true) {
                            $carousel.slick({
                                slidesToShow: slidesPerRow,
                                slidesToScroll: slidesPerRow,
                              	infinite: false,
                                dots: false,
                            }).on( 'beforeChange', function() {
                                if ( $( '.quickView--is-visible' ).length ) {
                                    QuickView.hide();
                                }
                            });

                            BambooDynamicCollections.init($carousel, 'slick');

                            $carousel.on('afterChange', function(event, slick, currentSlide){
	                            BambooDynamicCollections.changeSlide(event, currentSlide);
                            });
                        } else {
                          $carousel.slick({
                              slidesPerRow: slidesPerRow,
                              infinite: false,
                              dots: false,
                              responsive: [
                                  {
                                      breakpoint: 1024,
                                      settings: {
                                          slidesPerRow: 2
                                      }
                                  }
                              ]
                          }).on( 'beforeChange', function() {
                              if ( $( '.quickView--is-visible' ).length ) {
                                  QuickView.hide();
                              }
                          });
                        }
					}
				}

				function initMobileCarousel() {
					let mobileSlider = null;
					if ( !isMobileInitialized) {
						const carouselSliders = document.querySelectorAll('.js-collection-slider');

						for ( let i = 0, len = carouselSliders.length; i < len; i++ ) {
							const mobileCarousel = new Flickity( carouselSliders[i], {
								cellSelector: '.js-collectionBlock',
								prevNextButtons: false,
								pageDots: false,
								selectedAttraction: 0.08,
								friction: 0.8,
								freeScroll: true,
								contain: true
							});

							mobileSlider = mobileCarousel;

							$(window).on( 'resize', Reqs.debounce(function() {
								var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if ( windowWidth >= 768 ) {
									mobileCarousel.destroy()
								}

							}, 250));

							// Mobile devices swipe fix
							FlickitySmoothScrolling( mobileCarousel );

							if ($container.data().dynamicProducts === true) {
								BambooDynamicCollections.init($(carouselSliders[i]), 'flickity');

								mobileCarousel.on( 'change', function(index) {
									BambooDynamicCollections.changeSlide(null, index, carouselSliders[i], mobileCarousel);
								});
							}
						}



					}
					return mobileSlider;
				}

				function setArrowsPosition() {
					var $arrows = $carousel.find( '.slick-arrow' );
					var arrowTop = $carousel.find( '.collectionBlock-image' ).outerHeight() / 2;

					$arrows.css( 'top', arrowTop );
				}

				setArrowsPosition();

				return mobileSlider;

			},

			/* Gallery Slider */
			gallery: function(){
				var self = this;
				var slider = $('.js-slider');
				var options = {};

				slider.each( function () {
					var currentSlider = $(this),
						options = JSON.parse( currentSlider.data( 'slick' ).replace(/'/g, '"') );

					currentSlider.on('init', function() {
						$(this).removeClass('gallery-slider--is-loading');
					});

					currentSlider.slick( options );

					// Pause slider if it's outside the viewport to prevent elements shaking
					$(window).on( 'scroll.gallery',
						Reqs.debounce( function() {
							var isSliderVisible = isAnyPartOfElementInViewport(currentSlider.get( 0 ));

							if ( isSliderVisible && options.autoplay ) {
								currentSlider.slick( 'slickPlay' );
							} else {
								currentSlider.slick( 'slickPause' );
							}
						}, 150)
					);
				} );

				function isAnyPartOfElementInViewport(el) {

					const rect = el.getBoundingClientRect();
					const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
					const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

					const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
					const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

					return (vertInView && horInView);
				}
			},

			/* Mosaic Slider Mobile */
			mosaic: function() {
				var self = this;
				var slider = $('.js-mosaic__blocks');

				slider.each( function() {
					var currentSlider = $(this);

					self.initMobileSlider(currentSlider);
					$(window)
						.on( 'load', self.truncateMosaicText(currentSlider))
						.on( 'resize.mosaic', Reqs.debounce( function() {
							self.initMobileSlider(currentSlider)
						}, 250))
						.on( 'resize.mosaic', Reqs.throttle( function() {
							self.truncateMosaicText(currentSlider)
						}, 50));
				});

				Site.onPriceAdded();
			},

			truncateMosaicText: function(slider) {
				slider.find('.mosaic__block-text-title').trunk8({
					lines: 3
				});
			},

			/* Mosaic Slider Mobile */
			testimonials: function(){
				var self = this;
				var slider = $('.js-testimonials__blocks');

				slider.each( function() {
					var currentSlider = $(this);

					self.initMobileSlider(currentSlider);
					$(window).resize(
						Reqs.debounce( function() {
						self.initMobileSlider(currentSlider);
					}, 250));
				});
			},

			initMobileSlider: function(currentSlider) {
				var isMobile = $(window).width() < 768;
				var isSlickActive = currentSlider.hasClass('slick-initialized');
				var options = {
					'infinite': true,
					'autoplay': false,
					'speed': 300,
					'slidesToShow': 1,
					'arrows': true,
					'dots': false
				};

				if (currentSlider.hasClass('js-testimonials__blocks')) {
					options = $.extend({}, options, {
						'arrows': false,
						'dots': true
					})
				}

				// Init Slick on mobily only and destroy it otherwise
				if (isMobile && !isSlickActive) {
					currentSlider.slick( options );
				} else if (!isMobile && isSlickActive) {
					currentSlider.slick( 'unslick' );
				}
			},

			/* Logos list carousel */
			logosList: function(){
				var self = this;
				var slider = $('.js-logos-slider');
				var options = {
					'infinite': true,
					'autoplay': false,
					'speed': 300,
					'slidesToShow': 8,
					'centerPadding': '80px',
					'arrows': true,
					'dots': false,
					'responsive': [
						{
						  'breakpoint': 1440,
						  'settings': {
							'centerPadding': '40px',
							'slidesToShow': 6
						  }
						},
						{
						  'breakpoint': 1024,
						  'settings': {
							'centerPadding': '30px',
							'slidesToShow': 5
						  }
						},
						{
						  'breakpoint': 992,
						  'settings': {
							'centerPadding': '25px',
							'slidesToShow': 4
						  }
						},
						{
						  'breakpoint': 768,
						  'settings': {
							'centerPadding': '20px',
							'slidesToShow': 3
						  }
						},
						{
						  'breakpoint': 640,
						  'settings': {
							'centerPadding': '15px',
							'slidesToShow': 2
						  }
						},
						{
						  'breakpoint': 375,
						  'settings': {
							'centerPadding': '10px',
							'slidesToShow': 1
						  }
						}
					]
				};

				slider.each(function() {
					$( this ).slick( options );
				});
			}
		},

		/*
		 * Main Menu
		 */
		nav: {
			getWidth: function() {
				var ww = $(window).outerWidth();

				if(ww >= 1280) {
					return ww / 3;
				} else if(ww >= 768) {
					return ww * 2 / 3;
				} else {
					return ww;
				}
			},
			init: function(){
				$hamburger = $('#hamburger-menu');
				$body = $('body');
				$menuToggle = $('.js-menuToggle');
				$navSocialLink = $('.nav-social-link');
              	$navLocalizationLink = $('.nav-localization-link');
              	$navCurrencyLink = $('.nav-currency-link');
              	$menuLocalBack = $('.js-menuBack');
              	$menuToggleBack = $('.js-menuToggleBack');
				$transformElements = $('.bodyWrap, .header, .siteAlert');

				Site.nav.bindings();
				Site.nav.activeLinks();
			},
			bindings: function(){
				$menuToggle.on('click', function(e){
					e.preventDefault();

					$body.hasClass('nav--is-visible') ? Site.nav.hide() : Site.nav.show();
				});


              	$menuLocalBack.on('click', function(e){
					e.preventDefault();

					$('.nav-mobile-panel-localization').removeClass('open');
				});

              	$menuToggleBack.on('click', function(e){
					e.preventDefault();

					$('.nav-mobile-panel-currency').removeClass('open');
				});


				$('.nav-standard .menu li:has(a[aria-expanded])').hover(function() {
					$(this).addClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', true);
				}, function() {
					$(this).removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
				});

				$('.nav-standard .menu-item--meganav').hover(function() {
					dataLayer.push({
						event: 'UA',
						eventCategory: 'header_menu',
						eventAction: 'open',
					});
					$('.header').addClass('header--megamenu-visible');
					$(this).find('.visible-nav-link').removeAttr('tabindex');
				}, function() {
					$('.header').removeClass('header--megamenu-visible');
					$('.visible-nav-link').attr('tabindex', '-1');
				});

				// A11y
				$('.nav-standard .toggle-submenu').on( 'click', function(e) {
					var el = $(this),
						isSubmenuOpen = el.parent().hasClass( 'is-expanded' );

					if ( isSubmenuOpen ) {
						// Close mega menu
						Site.nav.submenuStandard.close();
					} else {
						Site.nav.submenuStandard.open( el );
					}
				});

				// Close header dropdowns and search on focus another elements or ESC key is pressed
				$('body').on('keyup', function(e) {
					if ( e.keyCode !== slate.utils.keyboardKeys.TAB && e.keyCode !== slate.utils.keyboardKeys.ESCAPE ) return;

					var $focusedElement = $(e.target),
						isSubmenuChild = $focusedElement.parents( '.submenu' ).length,
						isHamburgerChild = $focusedElement.parents( '.nav-hamburger' ).length;

					if ( e.keyCode === slate.utils.keyboardKeys.TAB ) {
						if ( !isSubmenuChild ) {
							// Close submenu or megamenu
							Site.nav.submenuStandard.close();
						}

						if ( !isHamburgerChild ) {
							// Close hamburger menu
							Site.nav.hide();
						}

					} else if ( e.keyCode === slate.utils.keyboardKeys.ESCAPE ) {
						Site.nav.submenuStandard.close();
						Site.nav.search.close();
						Site.nav.hide();
					}
				});

				$('.main-content').children().first().on('click', function(){
					Site.nav.hide();
				});

				$('.nav-hamburger .menu > .menu-item.has-submenu > a').on('click', function(e) {
					e.preventDefault();

					if ( $(this).parent().hasClass( 'is-expanded' ) ) {
						Site.nav.submenu.close( $(this).parent() );
					} else {
						Site.nav.submenu.open( $(this).parent() );
					}
				});

				$('.js-searchToggle').on('click', function(){
					if ( $('.nav-main').hasClass('search--is-visible') ){
						Site.nav.search.close();
					} else {
						var search = $(this).data( 'search-nav' );
						Site.nav.search.open( search );
					}
				});

				// Hide search modal on click outside
				$(document).on('click', function(e){
					if (!$(e.target).is('.nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *')) {
						if ($('.nav-main').hasClass('search--is-visible')){
							Site.nav.search.close();
						}
					}
				});

				$navSocialLink.on('click', function (e) {
					var $diamond = $(this).children('.diamond');
					$diamond.addClass('ripple-click');
					setTimeout(function(){
						$diamond.removeClass('ripple-click');
					},500);
				});

				// Close hamburger menu on body click
				$('body').on('click', function(e) {
					if (!$(e.target).is('.js-menuToggle, .js-menuToggle *, .nav-main *')) {
						Site.nav.hide();
					}
				});
			},
			show: function(){
				var navMenuWidth = $('.nav-hamburger').width() + 'px';
				$hamburger.addClass('open');

				$body.add('html').addClass('nav--is-visible');
              	$('.nav-hamburger__blocker').addClass('open');

				$('.header__icons a:not(.js-menuToggle)').attr('tabindex', '-1' );
				$('.nav-hamburger').find( 'button, a' ).removeAttr( 'tabindex' );

              	$navLocalizationLink.on('click', function(e){
                  	$('.nav-mobile-panel-localization').addClass('open');
				});

              	$navCurrencyLink.on('click', function(e){
                  	$('.nav-mobile-panel-currency').addClass('open');
				});
			},
			hide: function(){
				if ( !$body.hasClass( 'nav--is-visible')) return;

				$hamburger.removeClass('open');
				$body.add('html').addClass('nav--is-hiding');
				$transformElements.css({ 'transform': 'none' });
              	$('.nav-hamburger__blocker').removeClass('open');

				$(window).off('resize.siteNav');

				setTimeout(function(){
					$body.add('html').removeClass('nav--is-visible nav--is-hiding');
				}, 300);

				// close search too
				if ($('.nav-hamburger').hasClass('search--is-visible')){
					Site.nav.search.close();
				}

				$('.header__icons a').removeAttr('tabindex');
				$('.nav-hamburger').find( 'button, a' ).attr( 'tabindex', '-1' );
			},

			activeLinks: function(){
				var $menu_items = $(".menu-item"),
					$submenu_items = $('.submenu-item');

				$menu_items.each(function(){
					if ($(this).find('> a').attr('href')=== window.location.pathname) {
						$(this).addClass('is-active');
					}
					// if no top-level link is active, then a submenu link is probably active
					else {
						$submenu_items.each(function(){
							if ($(this).find('> a').attr('href')=== window.location.pathname) {
								$(this).addClass('is-active'); // activate the active submenu link
								$(this).closest('.menu-item.has-submenu').addClass('is-active'); // activate parent as well
							} else {
								return; // must be homepage or page not in menu
							}
						});
					}
				});
			},

			submenuStandard: {
				open: function(el) {
					// Close other mega menus
					el.parent().siblings('.menu-item--meganav').removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
					el.parent().siblings('.menu-item--meganav').find('.visible-nav-link').attr('tabindex', '-1');

					// Open selected mega menu
					el.attr('aria-expanded', true).parent().addClass('is-expanded');
					el.parent().find('.visible-nav-link').removeAttr('tabindex');

					// Header state when megamenu is open
					if ( el.parents('.menu-item--meganav').length ) {
						$('.header').addClass('header--megamenu-visible');
					}
				},
				close: function() {
					$('.visible-nav-link').attr('tabindex', '-1');
					$('.nav-standard .menu li').removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
					$('.header').removeClass('header--megamenu-visible');
				}
			},

			/*
			 * Sub Menus
			 */
			submenu: {
				open: function(el){
					var $menu = $('.menu'),
						$elSubMenu = $(el);
					$menu.addClass('submenu--is-visible');
					$elSubMenu.addClass('is-expanded').find('> .submenu').stop(true).slideDown('fast');
					$elSubMenu.find('.visible-nav-link').removeAttr('tabindex');
				},
				close: function(el){
					var link = $(el).children().first(),
						$menu = $('.menu'),
						$elSubMenu = $(el);
					$elSubMenu.removeClass('is-expanded').find('> .submenu').stop(true).slideUp('fast');
					$elSubMenu.find('.visible-nav-link').attr('tabindex', '-1');
				}
			},

			/*
			 * Search
			 */
			search: {
				open: function(search){
					$( '.js-searchToggle' ).attr( 'aria-expanded', true);
					$( search ).addClass( 'search--is-visible' );
					$( search ).find( '.nav-search-input, .nav-search-submit, .js-searchToggle--close' ).removeAttr( 'tabindex' );
					$( search ).find( '.nav-search-input' ).focus().select();
				},
				close: function(){
					$( '.nav-search-input, .nav-search-submit, .js-searchToggle--close' ).attr( 'tabindex', '-1' );
					$( '.js-searchToggle' ).attr( 'aria-expanded', false);

					var isSearchVisible = $( '.nav-main').hasClass( 'search--is-visible' );
					if ( isSearchVisible) {
						$( '.nav-main').addClass( 'search--is-hiding' );
						$( '.js-searchToggle--open' ).focus();
						setTimeout(function(){
							$( '.nav-main' ).removeClass( 'search--is-visible search--is-hiding');
						}, 300);
					}

				}
			}
		},

		/*
		 * Form Address Validation
		 */
		addresses: {
			addAddressForm: $(".js-addAddress > form"),
			editAddressForm: $(".js-editAddress > form"),
			init: function () {
				$addAddressForm = this.addAddressForm,
				$editAddressForm = this.editAddressForm;

				Site.addresses.validating();
			},
			validating: function () {
				$addAddressForm.add($editAddressForm).submit(function (e) {
					var isEmpty = true;

					// Display notification if input is empty
					$(this).find('input').not(".optional").each(function () {
						if (!$(this).val()) {
							$(this).next().addClass("validation--showup");
						} else {
							$(this).next().removeClass("validation--showup");
						}
					});

					// Detect whether form is valid
					$(this).find('input').not(".optional").each(function () {
						if (!$(this).val()) {
							isEmpty = false;
						}
					});
					if (!isEmpty) {
						return false;
					}
				});
			}
		},
		onPriceAdded: function() {
			
		},

		checkReviewsApp: function() {
			var checking = setInterval(function() {
				var reviewsAppInstalled = typeof(window.SPR) == 'function';

				if (!reviewsAppInstalled) {
					$('body').attr('data-app-reviews', 'not-installed');
				} else {
					$('body').removeAttr('data-app-reviews');
					clearInterval(checking);
				}
			}, 100);

			setTimeout(function() {
				clearInterval(checking);
			}, 15000);
		},

		animations: {
			init: function() {
				var self = this;
				var enableAnimations = $( 'body' ).hasClass( 'show-grid-items-transition' );

				if ( enableAnimations ) {
					// Allow animations
					$( 'body' ).addClass( 'allow-animations' );

					this.animateAll();
					$(window).on('scroll', Reqs.throttle(self.animateAll, 100));
					$(window).on('load', self.animateAll);
				}
			},

			animateAll: function() {
				var animatedElements = $('.will-animate');
				animatedElements.each(function() {
					var animationClass = 'animated ' + $(this).data('animation');
					if ($(this).visible(true)) {
						$(this).addClass(animationClass).removeClass('will-animate');
					}
				});
			}
		},

		initReviews: function() {
			var showReviews = (true),
				enableYotpo = (false),
				yotpoID = "";

			if ( enableYotpo && yotpoID != '' && typeof yotpo != 'undefined' && yotpo.initWidgets != 'undefined' ) {
				yotpo.initWidgets();
				$( '.star-clickable' ).removeAttr( 'tabindex' );
			} else if ( showReviews && typeof window.SPR == 'function' ) {
				window.SPR.initDomEls();
				window.SPR.loadBadges();
				window.SPR.loadProducts();
			}
		}
	}

	Site.init();
	Cart.init();
	$(document).ready(function() {
		Gmap.init();

		$(window).trigger('scroll');
	});

	Sections.init();
	Popup.init();

  	BambooAccordionHelper.init();

	Site.onPriceAdded();

	if ( $('.template-product').length ) {
		Product.init();
		RelatedProducts.init();
	}

	if ( $('.template-password').length ) {
		Password.init();
	}

	if ( $('.template-customers-login').length ) {
		Login.init();
	}

	if ( $('.template-customers-addresses').length ) {
		Addresses.init();
	}

	var showQuickView = (false);
	if ( showQuickView ) {
		QuickView.init();
	}

	slate.a11y.pageLinkFocus($(window.location.hash));

	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});
});
// end .ready()
$(document).one( 'touchstart', function() {
	Helpers.setTouch();
});

var popoverTimer,
Cart = {
	init: function(){
		var $cart = $( '#Cart' ),
// 			$popover = $( '#CartPopoverCont' ),
			enableAjaxCart = (true),
			bodyLock = 0;

		this.counter();

		$( window ).on( 'resize', Reqs.throttle( Site.setCartClosePosition, 10));

		/* Continue Shopping link - hide cart overlay if on desktop */
		$cart.on('click', '.js-continueShopping', function(e){
			e.preventDefault();
			var referrer = document.referrer;
			var origin = window.location.origin + '/';
			var isMobile = $(window).width() < 768;

			if ( !isMobile && !(window.location.href.indexOf('/cart') > -1) ){
				$('.js-cartToggle').trigger('click');
			} else {
				if ( referrer === origin ) {
					window.location.href = "/collections/novinki";
				} else {
					history.back(1);
				}
			}
		});

		// Don't init cart functions if ajax cart disabled
		if ( !enableAjaxCart ) return false;

		$( document ).off( 'click', '.js-cartToggle' );

		$('body').on('click', '.js-productForm-submit', function(e) {
			var $form = $(this).closest('form.productForm');
          	const selectedVariant = this.getAttribute('data-variant');

          if (selectedVariant) {
            if ( enableAjaxCart ) {
				e.preventDefault();

				if ($form.find('[type="file"]').length) return;

				Cart.submit($(this));
			}
          } else {
            e.preventDefault();
            const sizeSelector = document.getElementsByClassName('sizes-selector__title')[0];
            const sizeSelectorMobile = document.getElementsByClassName('sizes-selector--mobile')[0];
            sizeSelector.setAttribute('data-submit_on_select', 'true');

            if(screenSize.isMobile()) {
                $('body').addClass('body--has-overlay');
          		sizeSelectorMobile.classList.add('sizes-selector--open');
            }

            else {
              sizeSelector.click();
            }
          }
		});

		$(window).on( 'keyup', function(e) {
			if ( e.key === "Escape" ) {
				$body.removeClass('cart--is-visible');
				$cart.removeClass('open');
				$cart.addClass('close');
				$('#cartTotal').attr('aria-expanded', false);
// 				Cart.popover.hide($popover);
			}
		});
	},
	submit: function(el, properties = null, isGiftCard = false) {
		var $form = el.closest('form.productForm'),
			product_handle = el.attr("data-handle"),
			variant_id = $form.find('select[name="id"] option:selected').attr('value'),
			quantity = $form.find('.inputCounter').prop('value') || $form.find('#quantity').prop('value'),
			form_array = $form.serializeArray();

		var form_data = {};

		$.map(form_array, function(val, i){
		  form_data[val.name] = val.value;
		});


		$.ajax({
			method: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: form_data,
			success: function(product){
               	$('.button.js-cartToggle').removeClass('button--hidden');
                $('.js-productForm-submit').addClass('button--hidden');

				Cart.getCart(Cart.buildCart);
// 				Cart.popover.show(product);

				if (isGiftCard) {
					GiftCard.Modal.close();
				}
			},
			// If there are no products in the inventory
			error: function(data){
				$.ajax({
					method: 'GET',
					url: '/products/'+product_handle+'.js',
					dataType: 'json',
					success: function(product){
						var variants = product.variants,
								// variants is an array [0{},1{},2{}...]
								variant = $.each(variants, function(i, val){
									// val returns the contents of 0,1,2
									if (val.id == variant_id) {
										return variant_quantity = val.inventory_quantity; // set variant_quantity variable
									}
								}),
// 								$popover = $('#CartPopoverCont'), // same popover container used to show succesful cart/add.js
								error_details = "Sorry, looks like we don&#39;t have enough of this product. Please try adding fewer items to your cart.", // translation string
								tag = new RegExp('\[\[i\]\]'), // checks for [[i]]
								error = error_details; // set error to just default to error_details

						if (tag.test(error_details) == true){
							// [[i]] is part of the trans string, this can be whatever,
							// but in the tutorial we use [[i]] so leave it
							error = error_details.replace('[[i]]', variant_quantity); // re-set error with new string
						}

						el.html( "WOOPS!" ); // swap button text
						setTimeout(function(){
							el.html( "Добавить в корзину" ); // swap it back
						}, 1000);

// 						// clear popover timer, set at top of Cart object
// 						clearTimeout(popoverTimer);

// 						// empty popover, add error (with inventory), show it, remove click events so it doesn't open cart
// 						$popover.empty().append('<div class="popover-error">'+error+'</div>').addClass('is-visible').css({'pointer-events': 'none'});
// 						// set new instance of popoverTimer
// 						popoverTimer = setTimeout(function(){
// 							$popover.removeClass('is-visible').css({'pointer-events': 'auto'});
// 						}, 5000);
					},
					error: function(){
						console.log("Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed.");
					}
				});
			}
		});
	},
	popover: {
		show: function(product){

			var item = {},
//                 $popover = $('#CartPopoverCont'),
				unitPrice = '',
				source = $('#CartPopover').html(),
				template = Handlebars.compile(source),
				price = Shopify.formatMoney( product.final_price, Shopify.money_format_duplicate );
			// Unit price
			if ( product.unit_price_measurement ) {
				unitPrice = Shopify.formatMoney(product.unit_price, Shopify.money_format_duplicate) + ' ';
				if ( product.unit_price_measurement.reference_value != 1 ) {
					unitPrice += product.unit_price_measurement.reference_value;
				}
				unitPrice += product.unit_price_measurement.reference_unit;
			}

			// Product image
			if (product.image != null){
				var prodImg = product.image.replace(/(\.[^.]*)$/, "_150x$1").replace('http:', '');
			} else {
				var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
			}

			item = {
				item_count: product.quantity,
				img: prodImg,
				name: function(){
					name = product.product_title;

					if (name.length > 20){
						name = name.substring(0, 20) + ' ...';
					}

					return name;
				},
				variation: product.variant_title == 'Default Title' ? false : product.variant_title,
				price: product.price,
				price_formatted: price,
				unit_price: unitPrice
			}

// 			$popover.empty().append(template(item));

			// clear popover timer, set at top of Cart object
			clearTimeout(popoverTimer);

// 			$popover.addClass('is-visible');


			// set new instace of popoverTimer
// 			popoverTimer = setTimeout(function(){
// 				Cart.popover.hide($popover);
// 			}, 5000);
		},
		hide: function(el){
			el.removeClass('is-visible');
			setTimeout(function(){
				el.empty();
			}, 300);
		}
	},
	getCart: function(callback) {
	  $.getJSON('/cart.js', function (cart, textStatus) {
		if ((typeof callback) === 'function') {
		  callback(cart);
		}
		else {
		  ShopifyAPI.onCartUpdate(cart);
		}
	  });
	},
	buildCart: function (cart) {
		var self = this;
		var $cart = $('#Cart');
		var $body = $('body');


        // Klaviyo cart event. Start

        function batchFormatPrice(pricesToFormat, objectToFormat) {
          pricesToFormat.forEach(onePriceName => {
	      	objectToFormat[onePriceName] = Shopify.formatMoney(objectToFormat[onePriceName], "€{{amount_no_decimals}}");
          });
        }

        const cartKlaviyo = JSON.parse(JSON.stringify(cart));

        batchFormatPrice(
          ['total_price', 'items_subtotal_price', 'total_discount', 'original_total_price'],
          cartKlaviyo
        );

        cartKlaviyo.items.forEach(oneLineItem => {
          batchFormatPrice(
            [
              'original_price', 'discounted_price', 'final_line_price', 'line_price', 'final_price', 'total_discount',
              'price', 'original_line_price'
          	],
            oneLineItem
          );
        });

        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', cartKlaviyo]);

        // Klaviyo cart event. End



        // Bamboo. Criteo cart event. Start

		let bambooCriteoProducts = [];

		cart.items.forEach(oneItem => {
		  bambooCriteoProducts.push({
			id: oneItem.product_id,
			price: oneItem.discounted_price / 100,
			quantity: oneItem.quantity,
			name: oneItem.product_title,
			variant: oneItem.variant_id,
		  });
		});

        // Bamboo. Criteo cart event. End


		// Start with a fresh cart div
		$cart.empty();

		// Append close icon if page is not cart template only
		if ( !$body.hasClass( 'template-cart') ) {
          	$cart.append('<div class="container"><div class="js-cartToggle js-cartToggle-close cart-close icon-close"></div></div>');
		}

		// Show empty cart
		if (cart.item_count === 0) {
			$cart.append('<div class="min-height"><div class="cart-title cart-title--empty">\
							<h2>Корзина</h2>\
							<p>' + "Ваша корзина пуста" + '</p>\
							<a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">Продолжить покупки</a>\
						</div></div>');

			// Update cart total
			self.updateCartTotal();
			Site.setCartClosePosition();

			return;
		}

		// Handlebars.js cart layout
		var items = [],
			item = {},
			data = {},
			source = $("#CartTemplate").html(),
            template = source ? Handlebars.compile(source) : null;


        var blueTagProducts = [];

		// Add each item to our handlebars.js data
		$.each(cart.items, function(index, cartItem) {
            blueTagProducts.push(cartItem.product_id);

			var itemAdd = cartItem.quantity + 1,
				itemMinus = cartItem.quantity - 1,
				itemQty = cartItem.quantity,
				itemVariantId = cartItem.variant_id,
				discountsArray = cartItem.discounts,
				discounts = '',
				productPrice = '',
				productTotalPrice = '',
				unitPrice = '';

			// Get line price value
			if ( cartItem.original_price > cartItem.final_price ) {
				productPrice += '<s>' + Shopify.formatMoney( cartItem.original_price, Shopify.money_format_duplicate ) + '</s> ';
			}
			productPrice += '<span>' + Shopify.formatMoney( cartItem.final_price, Shopify.money_format_duplicate ) + '</span>';

				// Get total line price value
				if ( cartItem.original_line_price > cartItem.final_line_price ) {
					productTotalPrice += '<s>' + Shopify.formatMoney( cartItem.original_line_price, Shopify.money_format_duplicate ) + '</s> ';
				}
				productTotalPrice += Shopify.formatMoney( cartItem.final_line_price, Shopify.money_format_duplicate );

			// Get discounts
			if ( discountsArray.length ) {
				discounts += '<div class="cart-product-discounts">';
				for ( var j = 0; j < discountsArray.length; j++ ) {
					discounts += '<p>' + discountsArray[j].title + ' (-' + Shopify.formatMoney( discountsArray[j].amount, Shopify.money_format_duplicate ) + ')</p>';
				}
				discounts += '</div>';
			}

			// Unit price
			if ( cartItem.unit_price_measurement ) {
				unitPrice = Shopify.formatMoney(cartItem.unit_price, Shopify.money_format_duplicate) + ' ';
				if ( cartItem.unit_price_measurement.reference_value != 1 ) {
					unitPrice += cartItem.unit_price_measurement.reference_value;
				}
				unitPrice += cartItem.unit_price_measurement.reference_unit;
			}

			/* Hack to get product image thumbnail
			*   - If image is not null
			*     - Remove file extension, add _small, and re-add extension
			*     - Create server relative link
			*   - A hard-coded url of no-image
			*/

			if (cartItem.image != null){
				var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
			} else {
				var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
			}

			var prodName = cartItem.product_title,
				prodVariation = cartItem.variant_title;

			if (prodVariation == 'Default Title') {
				prodVariation = false;
			}

			const handle = cartItem.handle;

			let isAvailable = null;
			let filteredTags = [];

			let compareAtPrice = null

			$.ajax({
				url: `/products/${handle}.js`,
				async: false,
				dataType: 'json',
				success: function (product) {
					isAvailable = product.available;
					const tags = product.tags;
					compareAtPrice = product.compare_at_price
					const isOnSale = !!compareAtPrice;

					tags.forEach(tag => {
						if (tag === 'Скоро в продаже' || tag === 'Новинки') {
							if (tag === 'Скоро в продаже') {
								filteredTags.push('Скоро')
							} else {
								filteredTags.push(tag);
							}
						}
					})

					if (!isAvailable) {
						filteredTags.push('No stock')
					}

					if (isOnSale) {
						filteredTags.push('Sale');
					}

					if (!filteredTags.length) {
						filteredTags.push('No tag');
					}
				}
			});

			// Create item's data object and add to 'items' array
			item = {
				id: cartItem.product_id,
				url: cartItem.url,
				img: prodImg,
				name: prodName,
				variation: prodVariation,
				itemAdd: itemAdd,
				itemMinus: itemMinus,
				itemQty: itemQty,
				itemVariantId: itemVariantId,
				properties: cartItem.properties,
				price: cartItem.price,
				priceFormatted: productPrice,
				unitPrice: unitPrice,
				linePriceFormatted: productTotalPrice,
				discounts: discounts,
				vendor: cartItem.vendor,
				category: cartItem.product_type,
				// currency: $('.bamboo-currency-current')[0].innerHTML,
				cartProductClass: cartItem.gift_card ? 'cart-product card-product-gift-card' : 'cart-product',
				isAvailable: isAvailable,
				filteredTags: filteredTags,
				compareAtPrice: compareAtPrice ? Shopify.formatMoney( compareAtPrice, Shopify.money_format_duplicate ) : null
			};

			items.push(item);
		});

		// Update cart totals
		var totalDiscounts = '';
		var cartDiscounts = cart.cart_level_discount_applications;

		if ( cartDiscounts.length ) {
			totalDiscounts += '<p class="cart-discounts">';
			for ( var j = 0; j < cartDiscounts.length; j++ ) {
				totalDiscounts += '<span>' + cartDiscounts[j].title + ':</span>';
				totalDiscounts += '<span>-' + Shopify.formatMoney( cartDiscounts[j].total_allocated_amount, Shopify.money_format_duplicate ) + '</span>';
			}
			totalDiscounts += '</p>';
		}

		// const isTBD = CartTaxes.isTBD();

		// Gather all cart data and add to DOM
		data = {
			item_count: cart.item_count,
			items: items,
			note: cart.note,
			totalDiscounts: totalDiscounts,
			taxInfo: '',
			// taxInfo: isTBD ? '<p class="cart-tax-info"><span>TBD</span></p>' : '<p class="cart-tax-info">Без учета стоимости доставки</p>',
			totalPrice: Shopify.formatMoney(cart.total_price, Shopify.money_format_duplicate)
		}

        // Blue Tag Start
        window.blue_q = window.blue_q || [];
        window.blue_q.push(
            {event: "setCampaignId", value: "40D198DB-D94E-3403-C26AE5C9BCC17B3F"}
            ,{event: "setProductId", value: blueTagProducts.join(", ")}
            ,{event: "setPageType", value: "basket"}
        );
        // Blue Tag End


		// update cart slide-out with new cart
          if (template) {
            $cart.append(template(data));
          }


		// Update cart total
		Cart.updateCartTotal();

		Site.onPriceAdded();
		Site.setCartClosePosition();

		/**
		 * Re-init the ajax cart buttons.
		 * These are added to the handlebars template, but this
		 * js needs to fire to show them after the new
		 * cart is built and inserted.
		 * @see https://help.shopify.com/themes/customization/cart/add-more-checkout-buttons-to-cart-page
		 */
		if (window.Shopify && Shopify.StorefrontExpressButtons) {
			Shopify.StorefrontExpressButtons.initialize();
		}
	},
	/*
	 * Form Counter
	 */
	counter: function(){
		var self = this,
			$cart = $('#Cart');

		$cart.on( 'blur', '.inputCounter', function() {
			var el = $(this),
				value = $(this).val();

			self.inputCounter( el, value );
		});

		$cart.on('click', '.inputCounter-down', function(){
			var el = $(this),
				$input = el.siblings( '.inputCounter' ),
				value = parseInt( $input.val() ) - 1;

			self.inputCounter(el, value);
		}).on('click', '.inputCounter-up', function(){
			var el = $(this),
				$input = el.siblings( '.inputCounter' ),
				value = parseInt( $input.val() ) + 1;

			self.inputCounter(el, value);
		});

		/* Remove line item on x click */
		$cart.on( 'click', '.cart-product-remove', function() {
			var el = $(this);

			self.inputCounter(el, 0);
		});
	},

	// Product/Quick View Product Submit Form
	inputCounter: function( el, value ) {
		console.log(el)
		var self = this,
			$cart = $( '#Cart' ),
			$item = el.closest( '.line-item' ),
			$input = $item.find( '.inputCounter' ),
			prevValue = null;

		if (el[0].classList.contains('inputCounter')) {
			prevValue = el[0].defaultValue;
		}


		// Set quantity to 0 and remove the item
		if ( value == 0 ) {
			$input.closest( '.line-item' ).fadeOut( function() {
				$( this ).remove();
			} );

		// Prevent a negative quantity
		} else if (value < 0) {
			value = 0;
		}

		var qty = value;
		var changeDiff = prevValue - value;
		var id = $input.attr( 'id' );
		var line = parseInt( $item.index() + 1 );

		const quantityChange = prevValue ? Math.abs(changeDiff) : 1;


		const product = JSON.parse($item[0].dataset.product)



		$.ajax( {
			type: 'post',
			url: '/cart/change.js',
			dataType: 'json',
			data: {
				'quantity': qty,
				'line': line
			},
			success: function( cart ) {

				// if change counter
				if (prevValue) {
					// if increase
					if (changeDiff < 0) {
						window.googleTagManagerHandler.onAddToCart({...product}, quantityChange)
					}
					// if decrease
					else {
						window.googleTagManagerHandler.onRemoveFromCart({...product}, quantityChange)
					}
				}
				// if click "decrease"
				else if (el[0].classList.contains('inputCounter-down')) {
					window.googleTagManagerHandler.onRemoveFromCart({...product}, 1)
				}
				// if click "increase"
				else if (el[0].classList.contains('inputCounter-up')) {
					window.googleTagManagerHandler.onAddToCart({...product}, 1)
				}

				// if click "remove"
				else if (el[0].classList.contains('cart-product-remove')) {
					window.googleTagManagerHandler.onRemoveFromCart({...product}, +$input[0].value)
				}

				Cart.buildCart( cart );
			}
		});

		// remove line item if the quantity is 0
		if ( qty == 0 ) {
			$( this ).closest( '.line-item' ).fadeOut( function() {
				$( this ).remove();
				self.updateCartTotal();
			} );
		}
	},
	updateCartTotal: function() {
		$.getJSON('/cart.js', function(cart) {
          $selector = $('#CartToggleItemCount');

          if ( cart.item_count > 0 ) {
            $selector.removeClass("hide");
          }
          else {
          	$selector.addClass("hide");
          }

          $selector.html( cart.item_count );
		});
	}
};

/*
 * quickView AJAX methods
 *
 * Key:
 * * el = ELEMENT attached to, one or more .js-collectionBlock
 * * handle = product HANDLE, delivered from the front-end  attached to .js-quickView
 * * obj = product OBJECT, in JSON
 */

var QuickView = {
	selectors: {
		section: '[data-section-id]',
		productMedia: '[data-product-single-media-group]',
		productMediaSlider: '[data-product-single-media-slider]',
		productMediaWrapper: '[data-product-single-media-wrapper]',
		productMediaThumbs: '[data-product-single-media-thumbs]',
		productTitle: '[data-product-title]',
		productForm: '[data-product-form]',
		productDescription: '[data-product-description]',
		collectionBlock: '[data-collection-block]'
	},

	settings: {
		enableVideoLooping: false,
		showQuantity: false
	},

	init: function() {
		var self = this,
			isQuickViewLoading = this.isQuickViewLoading = false;

		$(document).on( 'click', '.js-quickView-button', function(e) {
			var $selector = $(this),
				el = $(this).closest( self.selectors.collectionBlock ), // the .collectionBlock that contains the product js-quickView;
				url = $(this).attr( 'href' ),
				sectionId = $selector.closest( self.selectors.section ).data( 'section-id' );

			if (!isQuickViewLoading) {
				self.isQuickViewLoading = true;
				el.addClass( 'quickView--is-loading' );

				// if loaded and visible
				if ( el.hasClass('is-loaded') && el.hasClass('quickView--is-visible') ) {
					self.hide( self );
				}

				// if loaded but not visible, no other quickViews open
				else if (el.hasClass('is-loaded') && !el.hasClass('quickView--is-visible') && !$('.quickView--is-visible').length) {
					self.show( el );
				}

				// if loaded and not visible, other quickViews are open
				else if (el.hasClass('is-loaded') && !el.hasClass('quickView--is-visible') && $('.quickView--is-visible').length) {
					self.hide( self );
					setTimeout(function(){
						self.show( el );
					}, 200);
				}

				// if not loaded yet, other quickViews open
				else if ( $('.quickView--is-visible').length ) {
					self.hide( self );
					setTimeout(function(){
						self.ajax( el, url, sectionId );
					}, 200);
				}

				// if not loaded yet, no other quickViews open
				else {
					self.ajax( el, url, sectionId );
				}
			}

			e.preventDefault();
		});
	},

	show: function( el ) {
		var self = this,
			sub = ($(window).height() - 600)/2,
			offset = el.children( '.quickView' ).offset().top,
			headerHeight = 60,
			scroll = offset - sub - headerHeight;

		el.addClass( 'quickView--is-active' );
		el.removeClass( 'quickView--is-loading' );

		$('html, body').animate({ scrollTop: scroll }, 200, function() {
			Site.onPriceAdded();

			if (el.hasClass('is-loaded')) {
				el.addClass('quickView--is-visible');
			} else {
				el.addClass('quickView--is-visible is-loaded');
			}

			self.isQuickViewLoading = false;
		});

		$('html, body').trigger( 'quickView:show' );
	},

	hide: function() {
		var $collectionBlock = $( this.selectors.collectionBlock ),
			isQuickViewVisible = $collectionBlock.hasClass( 'quickView--is-visible' );

		if ( isQuickViewVisible ) {
			$collectionBlock.removeClass( 'quickView--is-visible quickView--is-active quickView--is-loading' );
		}
		$collectionBlock.find( '.product-image.is-selected' ).trigger( 'mediaHidden' ).addClass( 'hide' );

		$('html, body').trigger( 'quickView:hide' );
	},

	ajax: function(el, url, sectionId ) {
		var self = this;

		el.addClass( 'quickView--is-loading' );

		$.ajax({
			url: url,
			cache: false,
			dataType: 'html'
		}).done(function( data ) {
			var productSectionId = 'product-template',
				productJSON = $(data).find( '#product-json' ).text(),
				productMediaJson = $(data).find( '#ModelJson-' + productSectionId ).html(),
				product = JSON.parse(productJSON),
				productMediaSlider = self.modifyProductMediaSettings( $(data).find( self.selectors.productMediaSlider ), self.settings ),
				productMediaThumbs = $(data).find( self.selectors.productMediaThumbs ).html(),
				productTitle = self.addProductTitleLink( $(data).find( self.selectors.productTitle ), url ),
				productForm = self.modifyProductFormIds( $(data).find( self.selectors.productForm ), product.id ),
				productDescription = $(data).find( self.selectors.productDescription ).html(),
				item = {},
				source = $( '#ProductQuickViewTemplate--' + sectionId ).html(),
				template = Handlebars.compile(source);

			item = {
				productMediaSlider: productMediaSlider,
				productMediaThumbs: productMediaThumbs,
				productTitle: productTitle,
				productForm: productForm,
				productDescription: productDescription,
				productMediaJson: productMediaJson
			};

			el.append( template(item) );
			el.attr( 'data-section-id', productSectionId );
			el.on( 'click', '.js-quickView-close', function(e) {
				e.preventDefault();
				self.hide( self )
			} );

			self.initProductMediaSlider( el );
			self.initProductVideo( el );
			self.initMediaSwitch( el );
			self.initShopifyXrLaunch( el );
			self.initVariants( el, product );
			self.initPaymentButton( el );
			self.show( el );

			$( 'html, body' ).trigger( 'quickView:ajax' );
		});
	},

	/* Product Slider */
	initProductMediaSlider: function( container ) {
		var self = this,
			$productSection = $( container ),
			$productImgSlider = $productSection.find( '.js-productImgSlider' ),
			$productImgContainer = $productSection.find( '.js-productImgContainer' ),
			$productImgSliderNav = $productSection.find( '.js-productImgSlider-nav' ),
			activeArrows = $productImgSlider.data( 'arrows' ),
			sliderNavArrows = $productImgSliderNav.find( '.js-slide' ).length > 3,
			isDraggable = !($productImgSlider.find( '.product-single__media--video' ).length || $productImgSlider.find( '.product-single__media--model' ).length),
			activeSlide = $productImgSlider.find( '.is-selected-product' ).index();

		activeSlide = activeSlide == -1 ? 0 : activeSlide;

		if ( $productImgSlider.find('.js-slide').length > 1 ) {
			$productImgSlider
				.on( 'ready.flickity', function() {
					$productImgSlider.attr( 'tabindex', '-1' );
					$productImgSlider.find( '.js-slide' ).attr( 'tabindex', '-1' );
				})
				.on( 'change.flickity', function( event, index ) {
					var $currentSlide = $productImgSlider.find( '.js-slide' ).eq( index ),
						$currentSlideImage = $productImgSlider.find( '.product-single__media--image' );

					if ( !$currentSlideImage.hasClass( 'lazyloaded' ) ) {
						$currentSlideImage.addClass( 'lazyload' );
					}
				})
				.on( 'settle.flickity', function( event, index ) {
					var $currentSlide = $productImgSlider.find( '.js-slide' ).eq( index ),
						mediaId = $currentSlide.data( 'media-id' );

					self.switchMedia( container, mediaId );
				});

			$productImgSlider.flickity({
				cellSelector: '.js-slide',
				prevNextButtons: activeArrows,
				arrowShape: 'M 69.65625 6.96875 A 3.0003 3.0003 0 0 0 67.875 7.875 L 27.875 47.875 A 3.0003 3.0003 0 0 0 27.875 52.09375 L 67.875 92.09375 A 3.0003 3.0003 0 1 0 72.125 87.875 L 34.25 50 L 72.125 12.09375 A 3.0003 3.0003 0 0 0 69.65625 6.96875 z',
				pageDots: false,
				initialIndex: activeSlide,
				draggable: isDraggable,
				adaptiveHeight: true,
				contain: true,
				wrapAround: true
			});

			// Mobile devices swipe fix
			FlickitySmoothScrolling( $productImgSlider );

			$productImgSliderNav.on( 'ready.flickity', function() {
				$productImgSliderNav.attr( 'tabindex', '-1' );
			});
			$productImgSliderNav.flickity({
				cellSelector: '.js-slide',
				asNavFor: $productImgSlider[0],
				initialIndex: activeSlide,
				pageDots: false,
				prevNextButtons: sliderNavArrows,
				arrowShape: 'M 69.65625 6.96875 A 3.0003 3.0003 0 0 0 67.875 7.875 L 27.875 47.875 A 3.0003 3.0003 0 0 0 27.875 52.09375 L 67.875 92.09375 A 3.0003 3.0003 0 1 0 72.125 87.875 L 34.25 50 L 72.125 12.09375 A 3.0003 3.0003 0 0 0 69.65625 6.96875 z',
				contain: true,
				wrapAround: sliderNavArrows
			});
		}
	},

	handleMediaFocus: function( e ) {
		// If not ENTER key (13) or TAB key (9)
		if (e.keyCode !== 13 && e.keyCode !== 9) return;

		var $container = $(e.currentTarget).closest( this.selectors.collectionBlock ),
			mediaId = $(e.currentTarget).data( 'thumbnail-id' ),
			slideIndex = $( this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', $container ).index(),
			flick = $( this.selectors.productMediaSlider, $container ).data('flickity');
			flickNav = $( this.selectors.productMediaThumbs, $container ).data('flickity');

		// Go to the related slide media
		if (flick && flick.isActive && slideIndex > -1 && e.keyCode === 13) {
			flick.select( slideIndex );
		}

		// Move thumbs to the selected one
		if (flickNav && flickNav.isActive && slideIndex > -1 ) {
			flickNav.select( slideIndex );
		}
	},

	switchMedia: function( container, mediaId ) {
		var $container = $( container ),
			$currentMedia = $( '[data-product-single-media-wrapper]:not(.hide)', $container ),
			$newMedia = $( '[data-product-single-media-wrapper]' + '[data-media-id="' + mediaId + '"]', $container ),
			$otherMedia = $( '[data-product-single-media-wrapper]:not([data-media-id="' + mediaId + '"])', $container ),
			isFocusEnabled = !$( 'body' ).hasClass( 'no-outline' );

		if ( isFocusEnabled ) $newMedia.focus();

		$currentMedia.trigger( 'mediaHidden' );
		$newMedia.removeClass( 'hide' ).trigger( 'mediaVisible' );
		$otherMedia.addClass( 'hide' );
	},

	initMediaSwitch: function( container ) {
		var self = this,
			$container = $( container ),
			$productThumbImages = $( '[data-thumbnail-id]', $container );

		if (!$productThumbImages.length) return;

		$productThumbImages
			.on( 'click', function(e) {
				e.preventDefault();
			})
			.on( 'keyup', self.handleMediaFocus.bind(self) );
	},

	initProductVideo: function( container ) {
		var $container = $( container ),
			sectionId = $container.data( 'section-id' );

		$( '[data-product-media-type-video]', $container).each(function() {
			var $video = $(this);
			ProductVideo.init($video, sectionId);
		});
	},

	initShopifyXrLaunch: function( container ) {
		var self = this,
			$container = $( container );

		$(document).on('shopify_xr_launch', function() {
			var $currentMedia = $( '[data-product-single-media-wrapper]' + ':not(.hide)', $container );
			$currentMedia.trigger('xrLaunch');
		});
	},

	initVariants: function( container, product ) {
		var selector = 'product-select--' + product.id + '-quickView';
		/**
		 * Reinitialize variant dropdown.
		 */
		new Shopify.OptionSelectors( selector, {
			enableHistoryState: false,
			product: product,
			onVariantSelected: Product.selectCallback
		});

		manageOptions( product );

		function manageOptions( obj ){
			if (obj['options'].length === 1 && obj['variants'].length) {
				if (obj['variants'][0].title === 'Default Title') {
					for (i = 0; i < obj['options'].length; i++) {
						$('#' + selector + '-option-'+[i]).closest('.productForm-block').hide();
					}
				} else {
					for (i = 0; i < obj['options'].length; i++) {
						$('#' + selector + '-option-'+[i]).closest('.selector-wrapper').attr('data-id', 'product-select-option-'+[i]).prepend('<span class="selectArrow"></span><label>'+obj['options'][0]+'</label>');
					}
				}
			} else if (obj['options'].length > 1){
				for (i = 0; i < obj['options'].length; i++) {
					$('#' + selector + '-option-'+[i]).closest('.selector-wrapper').attr('data-id', 'product-select-option-'+[i]).prepend('<span class="selectArrow"></span>');
				}
			}
		}
	},

	initPaymentButton: function( container ) {
		// Init dynamic checkout buttons
		var enablePaymentButton = (false),
			$addToCartButton = $( '.js-productForm-submit', container );

		if ( enablePaymentButton ) {
			$addToCartButton.addClass( 'add-to-cart-btn-style' );
			if (Shopify.PaymentButton) {
				Shopify.PaymentButton.init();
			}
		} else {
			$addToCartButton.removeClass( 'add-to-cart-btn-style' );
		}
	},

	modifyProductMediaSettings: function( productMediaSlider, settings ) {
		productMediaSlider.find( '.product-image' ).each( function() {
			$(this)
				.attr( 'data-enable-video-looping', settings.enableVideoLooping )
				.attr( 'data-show_quantity', settings.showQuantity )
				.attr( 'tabindex', '-1' );
		});
		return productMediaSlider.html();
	},

	modifyProductFormIds: function( productForm, productId ) {
		// Find all ID attributes and add "--quickView" suffix
		productForm.find( '[id]' ).each( function() {
			var currentId = $(this).attr( 'id' ),
				newId = currentId + '--' + productId + '-quickView';
			$(this).attr( 'id', newId );
		});

		return productForm.html();
	},

	addProductTitleLink: function( productTitle, url ) {
		var productTitleText = productTitle.find( '.product-title' ).text();
		productTitle.find( '.product-title' ).html( '<a href="' + url + '">' + productTitleText + '</a>' );
		return productTitle.html();
	}
};

var Product = {
	init: function( update ){
		var update = (typeof update !== 'undefined') ?  update : false;
		var isScrollable = $( '.product-layout--scrollable' ).length;
		var showShopBar = $( '#add-to-cart-bar' ).length;
		this.mfpOpen = true;
		this.initProductTabs();
		this.initProductVideo();
		this.initImageGallery();
		this.initMediaSwitch();
		this.initShopifyXrLaunch();
		this.initVariants();
		this.qtyAdjust();
		this.handleSelectCustomVariant();
      	this.customVimeoControl();

		if ( isScrollable ) {
			this.initScroller( update );
		} else {
			this.initProductMediaSlider();
		}

		if ( showShopBar ) {
			this.shopBar();
		}

		Site.onPriceAdded();
	},

	/* Product Slider */
	initProductMediaSlider: function() {
		var self = this,
			$productSection = $( '[data-section-type="product-template"]' ),
			$productImgSlider = $productSection.find( '.js-productImgSlider' ),
			$productImgSliderNav = $productSection.find( '.js-productImgSlider-nav' ),
			sliderId = '#' + $productImgSlider.attr( 'id' ),
			activeArrows = $productImgSlider.data( 'arrows' ),
			activeDots = $productImgSlider.data( 'dots' ),
			sliderNavArrows = $productImgSliderNav.find( '.js-slide' ).length > 3,
			isDraggable = !($productImgSlider.find( '.product-single__media--video' ).length || $productImgSlider.find( '.product-single__media--model' ).length),
			activeSlide = $productImgSlider.find( '.is-selected-product' ).index();

		activeSlide = activeSlide == -1 ? 0 : activeSlide;

		if ( $productImgSlider.find('.js-slide').length > 1 ) {
			$productImgSlider
				.on( 'ready.flickity', function() {
					$productImgSlider.attr( 'tabindex', '-1' );
					$productImgSlider.find( '.js-slide' ).attr( 'tabindex', '-1' );
				})
				.on( 'change.flickity', function( event, index ) {
					var $currentSlide = $productImgSlider.find( '.js-slide' ).eq( index ),
						$currentSlideImage = $productImgSlider.find( '.product-single__media--image' );

					if ( !$currentSlideImage.hasClass( 'lazyloaded' ) ) {
						$currentSlideImage.addClass( 'lazyload' );
					}

					// Disable lightbox when changing slides
					setTimeout(function() {
						self.mfpOpen = true;
					}, 10);
				})
				.on( 'dragStart.flickity', function( event, index ) {
					self.mfpOpen = false;
				}).on( 'settle.flickity', function( event, index ) {
					var $currentSlide = $productImgSlider.find( '.js-slide' ).eq( index ),
						mediaId = $currentSlide.data( 'media-id' );

					self.switchMedia( mediaId );
				});

			$productImgSlider.flickity({
				cellSelector: '.js-slide',
				prevNextButtons: activeArrows,
				arrowShape: 'M 69.65625 6.96875 A 3.0003 3.0003 0 0 0 67.875 7.875 L 27.875 47.875 A 3.0003 3.0003 0 0 0 27.875 52.09375 L 67.875 92.09375 A 3.0003 3.0003 0 1 0 72.125 87.875 L 34.25 50 L 72.125 12.09375 A 3.0003 3.0003 0 0 0 69.65625 6.96875 z',
				pageDots: activeDots,
				initialIndex: activeSlide,
				draggable: isDraggable,
				adaptiveHeight: true,
				contain: true,
				wrapAround: true,
              	imagesLoaded: true
			});

			// Mobile devices swipe fix
			FlickitySmoothScrolling( $productImgSlider );

			$productImgSliderNav.on( 'ready.flickity', function() {
				$productImgSliderNav.attr( 'tabindex', '-1' );
			});

			$productImgSliderNav.flickity({
				cellSelector: '.js-slide',
				asNavFor: sliderId,
				initialIndex: activeSlide,
				pageDots: false,
				prevNextButtons: sliderNavArrows,
				arrowShape: 'M 69.65625 6.96875 A 3.0003 3.0003 0 0 0 67.875 7.875 L 27.875 47.875 A 3.0003 3.0003 0 0 0 27.875 52.09375 L 67.875 92.09375 A 3.0003 3.0003 0 1 0 72.125 87.875 L 34.25 50 L 72.125 12.09375 A 3.0003 3.0003 0 0 0 69.65625 6.96875 z',
				contain: true,
				wrapAround: sliderNavArrows
			});
		}
	},

	initImageGallery: function() {
		var self =  this,
			$productSection = $( '[data-section-type="product-template"]' ),
			$productImgContainer = $productSection.find( '.js-productImgContainer' );

		if($productImgContainer.data('gallery') == "lightbox") {
			Reqs.lightbox();

            function toggleImageSize(e) {
              	var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

              	if (windowWidth < 550) return;

              	e.stopPropagation();

              	var target = e.target;
              	var zoom = target.dataset.zoom;

                if (zoom) {
                  	target.style.maxHeight = zoom;
                	target.dataset.zoom = "";
                } else {
                	target.dataset.zoom = target.style.maxHeight;
                  	target.style.maxHeight = "100%";
                }
            }

			$( $productImgContainer ).magnificPopup({
				delegate: 'a',
				type: 'image',
				closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-close"></button>',
				closeOnContentClick: true,
				gallery: {
					enabled: true,
					arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% icon-arrow-%dir%"></button>',
					tCounter: '%curr% / %total%',
					navigateByImgClick: false
				},
				disableOn: function() {
					return self.mfpOpen;
				}
			});
		}
	},

	/* Product Tabs */
	initProductTabs: function(){
		var $productTab = $('.js-product-tabs .product-tab');

		// Click the product-tab title to change the tab
		$productTab.on('click', '.product-tab-title', function(e) {
			e.preventDefault();
			$(this).parent('.product-tab').toggleClass('is-active');

			var $productInfo = $('.js-productInfo');
			var productInfoHeight = $('.product-info__wrapper').outerHeight();
			var productImagesHeight = $('.product-layout-images').outerHeight();

			productInfoHeight > productImagesHeight ? $productInfo.addClass('product-info__wrapper--static') : $productInfo.removeClass('product-info__wrapper--static');

			$(window).trigger('scroll');
		});


		var $socialIcons = $('.socialBar a');
		$socialIcons.on('click', function () {
			var $diamond = $(this).children('.diamond');
			$diamond.addClass('ripple-click');
			setTimeout(function(){
				$diamond.removeClass('ripple-click');
			}, 2000);
		});
	},

	initScroller: function( update ) {
		var self = this,
			productImages = $( '.product-image' ).length,
			$mobileSlider= $('.js-productImgScroller');

		if (productImages > 1) {
			var isPageLoaded = false,
				$row = $('.product'),
				$productImg = $('.product-image'),
				$productImgScroller = $('.js-productImgScroller'),
				$productImgNav = $('.js-productImgScroller-nav'),
				$productInfo = $('.js-productInfo'),
                mouseOnScroller = false;

			// Adjust thumbnails position if change setting in TE
			if ( update ) stickyThumbnails();

			$(window)
				.on('load', function() {
					isPageLoaded = true;
				});

			$productImgScroller
				.on('scroll', Reqs.throttle(stickyThumbnails, 10));

			// Bind product thumb image click to scroll function
			$productImgNav.on('click', '.js-product-single__thumbnail', function(e) {
				e.preventDefault();

				var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

				if (windowWidth >= 1024) {
					var id = $(this).parent().data( 'id' ),
						$selectedImage = $('.product-image[data-id="' + id + '"]'),
						headerHeight = 60,
						additionalSpace = 40;

					if ( $selectedImage.length ) {
						var mediaId = $selectedImage.data( 'media-id' );
						if ( isPageLoaded || update ) {
                          	var selectedImageOffsetTop = $selectedImage.parent().scrollTop() + $selectedImage.offset().top - $selectedImage.offsetParent().offset().top;
							$productImgScroller
								.stop( true, false )
								.animate({ scrollTop: selectedImageOffsetTop }, 500, function() {
									Product.switchMedia( mediaId )
								});
						}
					}
				}
			});

			$(window).on('resize.js-product-template', Reqs.throttle( function(){
				checkProductInfoHeight();
			}, 50));

            $(window).on('load', function () {
              	checkProductInfoHeight();
              	setTimeout(checkProductInfoHeight, 1000);
            });

          	$productImgScroller.on('mouseenter', function () {mouseOnScroller = true;});

          	$productImgScroller.on('mouseleave', function () {mouseOnScroller = false;});

			$('.js-productImgScroller').height($('.product-single__media.lazyloaded').innerHeight())
			initMobileSlider();

			function stickyThumbnails() {
				var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				if (windowWidth >= 1024) {
					var scrolled = $productImgScroller.scrollTop();

					for ( var i = $productImg.length - 1; i >= 0; i--) {
						var $currentProduct = $( '.product-image' ).eq( i ),
							id = $currentProduct.data( 'id' ),
							productOffset = parseInt( $currentProduct.parent().scrollTop() + $currentProduct.offset().top - $currentProduct.offsetParent().offset().top);

						if (scrolled + 200 >= productOffset) {
							$productImgNav.find('.product-single__media-thumb[data-id="' + id + '"]').addClass('active').siblings().removeClass('active');
							break;
						}
					}
				} else {
					$productImgNav.removeClass('is-sticky stick-to-bottom');
					$productInfo.removeClass('is-sticky stick-to-bottom');
					$productInfo.css({ right: 'auto', width: 'auto' });
				}
			}
		}


		// If product layout is scroller and is mobile then load slider
		function initMobileSlider() {
			var $productImgSlider = $('.js-productImgScroller'),
				$productImgSliderNav = $('.js-productImgScroller-nav'),
				activeArrows = $productImgSlider.data('arrows'),
				activeDots = $productImgSlider.data('dots'),
				sliderNavArrows = $productImgSliderNav.find('.js-slide').length > 3,
				isDraggable = !($productImgSlider.find( '.product-single__media--video' ).length || $productImgSlider.find( '.product-single__media--model' ).length),
				activeSlide = $productImgSlider.find('.is-selected-product').index();
			activeSlide = activeSlide == -1 ? 0 : activeSlide;

			var flickity = $('.js-productImgScroller').data('flickity'),
				flickityNav = $('.js-productImgScroller-nav').data('flickity');

			if ( $productImgSlider.find('.js-slide').length > 1 ) {
				if (flickity == undefined) {

					$productImgSlider.on( 'change.flickity', function( event, index ) {
						var $currentSlide = $productImgSlider.find('.js-slide').eq( index );
						if ( !$currentSlide.hasClass( 'lazyloaded') ) {
							$currentSlide.addClass( 'lazyload');
						}
					});

					const settings = {
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: false,
						mobileFirst: true,
						arrows: false,
						dots: true,
						adaptiveHeight: true,
						responsive: [
							{
								breakpoint: 1024,
								settings: "unslick"
							}
						]
					};

					$mobileSlider.slick(settings);

					$(window).on('resize', function() {
						if( $(window).width() < 1024 && !$mobileSlider.hasClass('slick-initialized')) {
							$mobileSlider.slick(settings);
						}
					});
				}
			}
		}
	},

	handleMediaFocus: function( e ) {
		// Do nothing if not ENTER key (13) or TAB key (9)
		if (e.keyCode !== 13 && e.keyCode !== 9) return;

		var $container = $( e.currentTarget ).closest( '.js-product-template' ),
			mediaId = $(e.currentTarget).data( 'thumbnail-id' ),
			slideIndex = $( '[data-product-single-media-wrapper]' + '[data-media-id="' + mediaId + '"]', $container ).index(),
			flick = $( '.js-productImgContainer', $container ).data('flickity'),
			flickNav = $( '.js-productImgSlider-nav', $container ).data('flickity');

		// Go to the related slide media
		if (flick && flick.isActive && slideIndex > -1 && e.keyCode === 13 ) {
			flick.select( slideIndex );
		}

		// Move thumbs to the selected one
		if (flickNav && flickNav.isActive && slideIndex > -1 ) {
			flickNav.select( slideIndex );
		}
	},

	switchMedia: function( mediaId ) {
		var $container = $( '.js-product-template' ).parent(),
			$currentMedia = $( '[data-product-single-media-wrapper]:not(.hide)', $container ),
			$newMedia = $( '[data-product-single-media-wrapper]' + '[data-media-id="' + mediaId + '"]', $container ),
			$otherMedia = $( '[data-product-single-media-wrapper]:not([data-media-id="' + mediaId + '"])', $container ),
			isFocusEnabled = !$( 'body' ).hasClass( 'no-outline' );

		if ( isFocusEnabled ) $newMedia.focus();

		$currentMedia.trigger( 'mediaHidden' );
		$newMedia.removeClass( 'hide' ).trigger( 'mediaVisible' );
		$otherMedia.addClass( 'hide' );
	},

	pauseOtherMedia: function( mediaId ) {
		var $currentMedia = $( '[data-product-single-media-wrapper]' + '[data-media-id="' + mediaId + '"]' ),
			$otherMedia = $( '[data-product-single-media-wrapper]:not([data-media-id="' + mediaId + '"])' );

		$currentMedia.removeClass( 'hide' );
		$otherMedia.trigger( 'mediaHidden' ).addClass( 'hide' );
	},

	initMediaSwitch: function() {
		var self = this,
			$container = $( '.js-product-template' ).parent(),
			$productThumbImages = $( '[data-thumbnail-id]', $container );

		if (!$productThumbImages.length) return;

		$productThumbImages
			.on( 'click', function(e) {
				e.preventDefault();
			})
			.on( 'keyup', self.handleMediaFocus.bind(self) );
	},

	initProductVideo: function() {
		var $container = $( '.js-product-template' ).parent(),
			sectionId = $container.data( 'section-id' );

		$( '[data-product-media-type-video]', $container).each(function() {
			var $video = $(this);
			ProductVideo.init($video, sectionId);
		});
	},

	initShopifyXrLaunch: function() {
		var self = this,
			$container = $( '.js-product-template' ).parent();

		$(document).on('shopify_xr_launch', function() {
			var $currentMedia = $( '[data-product-single-media-wrapper]' + ':not(.hide)', $container );
			$currentMedia.trigger('xrLaunch');
		});
	},

	initVariants: function() {
		/**
		 * Initialize variants dropdown.
		 */
		var container = $( '.js-product-template' );
		var productJSON = $('#product-json').text();
		var product = JSON.parse(productJSON);

		new Shopify.OptionSelectors('product-select', {
			enableHistoryState: true,
			product: product,
			onVariantSelected: Product.selectCallback
		});

		manageOptions( product );

		function manageOptions( obj ){
		  if (obj['options'].length === 1 && obj['variants'].length){
			if (obj['variants'][0].title === 'Default Title') {
			  for (i = 0; i < obj['options'].length; i++) {
				$('#product-select-option-'+[i]).closest('.productForm-block').hide();
			  }
			} else {
			  for (i = 0; i < obj['options'].length; i++) {
				$('#product-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', 'product-select-option-'+[i]).prepend('<span class="selectArrow"></span><label>'+obj['options'][0]+'</label>');
			  }
			}
		  } else if (obj['options'].length > 1){
			for (i = 0; i < obj['options'].length; i++) {
			  $('#product-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', 'product-select-option-'+[i]).prepend('<span class="selectArrow"></span>');
			}
		  }
		}
	},

	/*
	 * Sticky "Shop" Bar in product.liquid
	 * Hidden via CSS under 768px viewport size
	 */
	shopBar: function() {
		var product = JSON.parse(document.getElementById( 'product-json' ).innerHTML);
		var $productForm = $('.productForm');
		var $shopBar = $('#add-to-cart-bar');
		var $selectors = $( 'select', $shopBar );
		var $productContainer = $( '.js-product-template' );
		var $siteFooter = $( '.site-footer' );

		new Shopify.OptionSelectors('product-bar-select', {
			enableHistoryState: true,
			product: product,
			onVariantSelected: Product.selectCallback
		});

		manageOptions( product );

		function manageOptions( obj ) {
			if (obj['options'].length === 1 && obj['variants'].length){
				if (obj['variants'][0].title === 'Default Title') {
					for (i = 0; i < obj['options'].length; i++) {
						$('#product-bar-select-option-'+[i]).closest('.productForm-block').hide();
					}
				} else {
					for (i = 0; i < obj['options'].length; i++) {
						$('#product-bar-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', '#product-bar-select-option-'+[i]).prepend('<span class="selectArrow"></span><label>'+obj['options'][0]+'</label>');
					}
				}
			} else if (obj['options'].length > 1){
				for (i = 0; i < obj['options'].length; i++) {
					$('#product-bar-select-option-'+[i]).closest('.selector-wrapper').attr('data-id', '#product-bar-select-option-'+[i]).prepend('<span class="selectArrow"></span>');
				}
			}
		}

		// Update shop bar on product form variant change
		$shopBar.on( 'change', 'select', function(e) {
			var id = $(this).attr('id');
			var optionSelected = $(this).val();
			id = id.replace( '-bar', '' );

			$productForm.find('select#' + id ).val( optionSelected ).triggerHandler( 'change' );
		});

		// Update shop bar on product form variant change
		$productForm.on('change', 'select', function(e) {
			var id = '#' + $(this).attr('id');
			var optionSelected = $(this).val();
			id = id.replace( 'product-', 'product-bar-' );

			$( id ).val( optionSelected ).triggerHandler( 'change' );
		});

		$(window).on( 'scroll',
			Reqs.throttle( function(){
				var scrolled = $(window).scrollTop();

				if ( $productContainer.length && $shopBar.length ) {
					var productContainerOffset = $productContainer.offset().top;

					if ( scrolled > productContainerOffset ) {
						$shopBar.addClass('product-bar--is-visible');
						$siteFooter.addClass('site-footer--push')
					} else if ( scrolled < productContainerOffset - 60 ) {
						$shopBar.removeClass('product-bar--is-visible');
						$siteFooter.removeClass('site-footer--push')
					}
				}
			}, 100)
		);
	},

	// this is what is being called from the product.liquid
	selectCallback: function(variant, selector) {
      	$('.button.js-cartToggle').addClass('button--hidden');
		$('.js-productForm-submit').removeClass('button--hidden');

		Product.callback({
			money_format: "",
			variant: variant,
			selector: selector
		});
	},

	callback: function(options){
		var container = $(options.selector.variantIdField).closest( '[data-section-id]' ),
			moneyFormat = options.money_format,
			variant = options.variant,
			selector = options.selector;

			//el is options.selector.variantIdField, the tie that binds
			var gold = $(options.selector.variantIdField).attr('id');
			var id = gold.replace(/\D/g, '');
			var fp = $( '.featured-product--' + id);

		if ( $(options.selector.variantIdField).parents( '.featured-product' ).length > 0 ) {

			var $submit = $(fp).find('.js-productForm-submit'),
				$price = $(fp).find('.product-price'),
				$normal_price = $(fp).find('.product-normal-price'),
				$sale_price = $(fp).find('.product-sale-price'),
				$compare_price = $(fp).find('.product-compare-price'),
				$unit_price = $(fp).find('.product-unit-price'),
				$counter = $(fp).find('.js-counter').not('.cart-product-quantity .js-counter'),
				$sale_container = $price.find('.sale'),
				$notification_form = $(fp).find( '.notification-form' );
		} else {
			var $submit = $('.js-productForm-submit'),
				$price = $('.product-price'),
				$normal_price = $('.product-normal-price'),
				$sale_price = $('.product-sale-price'),
				$compare_price = $('.product-compare-price'),
				$unit_price = $('.product-unit-price'),
				$counter = $('.js-counter').not('.cart-product-quantity .js-counter'),
				$sale_container = $price.find('.sale'),
				$notification_form = $( '.notification-form' );
		}


		if (variant) {
			if (variant.available) {
				$submit.removeClass( 'is-disabled' ).prop( 'disabled', false ).html( $submit.attr("data-title") );
				$counter.css({'opacity': 1, 'pointer-events': 'auto'});
				$price.css({'opacity': 1});

				$price.attr('data-price', variant.price);
				// $normal_price.html(Shopify.formatMoney(variant.price, Shopify.money_format));
				$notification_form.addClass('visually-hidden');
				if (variant.compare_at_price != null){
					if (variant.compare_at_price > variant.price) {
						if ($sale_container.length){
							// $compare_price.html(Shopify.formatMoney(variant.compare_at_price, Shopify.money_format));
							// $sale_price.html(Shopify.formatMoney(variant.price, Shopify.money_format));
						} else {
							// $price.append('<div class="sale" itemprop="price"><strike class="product-compare-price money"></strike>&nbsp;<span class="product-sale-price money"></span></div>');
							// $compare_price.html(Shopify.formatMoney(variant.compare_at_price, Shopify.money_format));
							// $sale_price.html(Shopify.formatMoney(variant.price, Shopify.money_format));
						}
						$normal_price.hide();
						$sale_container.show();
					} else if (variant.compare_at_price <= variant.price) {
						if($normal_price.length) {
							$normal_price.html(Shopify.formatMoney(variant.price, Shopify.money_format_duplicate));
						} else {
							$price.append('<div class="product-normal-price" itemprop="price">'+Shopify.formatMoney(variant.price, Shopify.money_format_duplicate)+'</div>');
						}
						// $sale_container.hide();
						// $normal_price.show();
					}
				} else {
					// $sale_container.hide();
					// $normal_price.show();

				}
				document.addEventListener('shopify:payment_button:loaded', showButtons($submit));
				function showButtons($submit){
				  var sibling = $submit.next();
				  if($(sibling).hasClass('shopify-payment-button')){
						$(sibling).show();
				  }
				}
			}
			// this variant sold out
			else {
				const dropdownTitle = document.getElementsByClassName('sizes-selector__title')[0];
              	dropdownTitle.innerHTML = variant.title;

              const $el = $(`.sizes-selector__item[data-id=${variant.id}]`);
				const showAddToCartButton = $el.data('show-add-to-cart-button');
				const isShowFastDeliveryMessage = $el.data('show-fast-delivery-message');

              Product.changeButtons(showAddToCartButton, isShowFastDeliveryMessage )


				$price.attr('data-price', variant.price);
				// $normal_price.html(`<span class="money">${Shopify.formatMoney(variant.price, Shopify.money_format)}</span>`);
				$notification_form.removeClass('visually-hidden');

				document.addEventListener('shopify:payment_button:loaded', checkButtons($submit));
				function checkButtons($submit){
				  var sibling = $submit.next();
				  if($(sibling).hasClass('shopify-payment-button')){
						$(sibling).hide();
				  }
				}

				if (variant.compare_at_price != null){
					if (variant.compare_at_price > variant.price) {
						if ($sale_container.length){
							// $compare_price.html(Shopify.formatMoney(variant.compare_at_price, Shopify.money_format));
							// $sale_price.html(Shopify.formatMoney(variant.price, Shopify.money_format));
						} else {
							// $price.append('<div class="sale" itemprop="price"><strike class="product-compare-price money"></strike>&nbsp;<span class="product-sale-price money"></span></div>');
							// $compare_price.html(Shopify.formatMoney(variant.compare_at_price, Shopify.money_format));
							// $sale_price.html(Shopify.formatMoney(variant.price, Shopify.money_format));
						}
						$normal_price.hide();
						$sale_container.show();
					} else if (variant.compare_at_price <= variant.price) {
						if($normal_price.length) {
							$normal_price.html(Shopify.formatMoney(variant.price, Shopify.money_format_duplicate));
						} else {
							$price.append('<div class="product-normal-price" itemprop="price">'+Shopify.formatMoney(variant.price, Shopify.money_format_duplicate)+'</div>');
						}
						$sale_container.hide();
						$normal_price.show();
					}
				} else {
					$sale_container.hide();
					$normal_price.show();
				}
			}

			// Update unit price
			if ( variant.unit_price_measurement ) {
				var unitPrice = Shopify.formatMoney(variant.unit_price, Shopify.money_format_duplicate) + ' ';
				if ( variant.unit_price_measurement.reference_value != 1 ) {
					unitPrice += variant.unit_price_measurement.reference_value;
				}
				unitPrice += variant.unit_price_measurement.reference_unit;

				$unit_price.html( unitPrice );
			}

			Product.showVariantImage(variant, container);
		} else {
			$notification_form.removeClass( 'visually-hidden' );
			$submit.addClass('is-disabled').prop('disabled', true).html( "Unavailable" );
			document.addEventListener('shopify:payment_button:loaded', checkButtons($submit));
				function checkButtons($submit){
				  var sibling = $submit.next();
				  if($(sibling).hasClass('shopify-payment-button')){
						$(sibling).hide();
				  }
				}
		}

		Site.onPriceAdded();
	},

	// show variant image within quickView or within slideshow (mobile product page)
	showVariantImage: function(variant, container) {
		var variantMediaId = variant.featured_media ? variant.featured_media.id : '',
			variantID = variant.id,
			$productImage = container.find('.product-image'),
			$imgSlider = container.find('.js-productImgSlider'),
			$imgScrollerNav = container.find('.productImgScroller-nav'),
			flick = $imgSlider.data('flickity');

		// Activate image slide in mobile view
		if ( flick && flick.isActive) {
			var $variantSlide = $imgSlider.find('[data-id="' + variantMediaId + '"]');

			if ($variantSlide.index() != -1) {
				flick.select($variantSlide.index());
			}

			$productImage.removeClass('is-selected-product');
			$variantSlide.addClass('is-selected-product');
		} else {
			var $variantThumb = $imgScrollerNav.find('[data-id="' + variantMediaId + '"] .js-product-single__thumbnail');

			if ( $variantThumb.length ) {
				$variantThumb.trigger('click');
			}
		}
	},

	qtyAdjust: function() {
		// Setup listeners to add/subtract from the input
		var $body = $( 'body' );
		$body.off( 'click', '.js-qty__adjust-btn' );
		$body.on( 'click', '.js-qty__adjust-btn', function(e) {
			e.preventDefault();
			var $adjustBtn = $(this),
				$qtySelector = $(this).siblings( 'input[name="quantity"]' );
				qty = validateQty( parseInt($qtySelector.val().replace(/\D/g, '') ));

			// Add or subtract from the current quantity
			if ( $adjustBtn.hasClass( 'increase' )) {
				qty += 1;
			} else {
				qty -= 1;
				if (qty < 1) qty = 1;
			}

			// Update the input's number
			$qtySelector.val(qty);
		});

		// Prevent 0 quantity
		$body.off( 'focusout', '.qty__adjust > input' );
		$body.on( 'focusout', '.qty__adjust > input', function(e) {
			var currentValue = $(this).val();
			if ( !currentValue ) $(this).prop( 'value', 1 );
		} );

		$body.off( 'keydown', '.qty__adjust > input' );
		$body.on( 'keydown', '.qty__adjust > input', function(e) {
			var currentValue = $(this).val();
			if ( e.keyCode === 13 && !currentValue ) $(this).prop( 'value', 1 );
		});

		function validateQty(qty) {
			if((parseFloat(qty) != parseInt(qty)) || isNaN(qty)) {
				qty = 1;
			}
			return qty;
		};
	},

	handleSelectCustomVariant: function() {
      const sizesSelectorMobile = $('.sizes-selector--mobile');
      const sizesSelectorClose = $('.sizes-selector__close');
      if (sizesSelectorMobile.length) {
      	sizesSelectorMobile.detach().appendTo('body')
      }

		const dropdownTitle = document.getElementsByClassName('sizes-selector__title')[0];
		const dropdownList = document.getElementsByClassName('sizes-selector__list')[0]

		const sizes =  document.querySelectorAll('.js-productSizesSelector .sizes-selector__item');

		sizes.forEach(size => {
			size.addEventListener('click', e => {
				const id = size.getAttribute('data-id')
				const title = size.getAttribute('data-title')
				const showAddToCartButton = size.getAttribute('data-show-add-to-cart-button');
				const isShowFastDeliveryMessage = size.getAttribute('data-show-fast-delivery-message');
				const addToCartButton =  document.getElementById('AddToCart');

				this.changeVariant(id, title);
				this.changeButtons(showAddToCartButton, isShowFastDeliveryMessage);


				dropdownTitle.classList.remove('sizes-selector__title--opened');
				dropdownList.style.display = 'none';
				dropdownTitle.innerHTML = title;
				// emailWhenAvailableSizes.innerHTML = title;
				// emailWhenAvailableSize.innerHTML = title;
				// emailWhenAvailableSizes.setAttribute('data-variant', id);
              	addToCartButton.setAttribute('data-variant', id);
              	sizesSelectorClose.click();


                if (dropdownTitle.getAttribute('data-submit_on_select')) {
					if (showAddToCartButton)  {
						addToCartButton.click();
					} else {
						// emailWhenAvailableButton.click();
					}

                  dropdownTitle.setAttribute('data-submit_on_select', '');
                }
			})
		})

		dropdownTitle.addEventListener('click', function() {
			if (this.classList.contains('sizes-selector__title--opened')) {
				this.classList.remove('sizes-selector__title--opened');
				dropdownList.style.display = 'none';
			} else {
				this.classList.add('sizes-selector__title--opened');
				dropdownList.style.display = 'block';
			}
		})

        $('.sizes-selector__close').click(function() {
        	$('.sizes-selector--mobile').removeClass('sizes-selector--open');
          	$('body').removeClass('body--has-overlay');
        })
	},

	changeVariant: function(id, title) {
		const productSelect = document.getElementById('product-select');
		const singleOptionSelector = document.querySelectorAll('.single-option-selector')[0];

		productSelect.value = id;
		productSelect.dispatchEvent(new Event('change'));

		singleOptionSelector.value = title;
		singleOptionSelector.dispatchEvent(new Event('change'));

		document.querySelector('.js-productSizesSelector').setAttribute('data-id', id)

	},

	changeButtons: function (showAddToCartButton, isShowFastDeliveryMessage) {
		const addToCartButton = document.getElementById('AddToCart')

		const fastDeliveryMessageEl = document.querySelector('.product__banner_fast-delivery');

		if (isShowFastDeliveryMessage === 'true') {
			if (!fastDeliveryMessageEl) {
				const notificationDiv = document.createElement('div');
				notificationDiv.className = "product__banner product__banner_fast-delivery";
				notificationDiv.innerHTML = "Доставим это изделие быстрее — за 2–5 дней";

				const productButtons = document.querySelector('.product-buttons');
				if (productButtons) {
					productButtons.insertAdjacentElement('beforebegin', notificationDiv);
				}
			}
		} else {
			if (fastDeliveryMessageEl) {
				fastDeliveryMessageEl.remove();
			}
		}

		if (showAddToCartButton === true || showAddToCartButton === 'true') {
			addToCartButton.classList.remove('hide-at-all')
			// emailWhenAvailableButton.classList.add('btn_hidden')
		} else {
				// emailWhenAvailableButton.classList.remove('btn_static')
				// emailWhenAvailableButton.classList.remove('btn_hidden')
				// emailWhenAvailableButton.classList.remove('emailWhenAvailable__btn_grey')
				addToCartButton.classList.add('hide-at-all')
			}

	},

    customVimeoControl: function() {
      VimeoVideo = {
        playButton: null,
        player: null,

        init: function() {
          VimeoVideo.playButton = document.getElementById('vimeo-player-btn');
          const video = document.getElementById('vimeo-player');

          if (video) {
              VimeoVideo.connectApi();

              VimeoVideo.player = new Vimeo.Player(video);

              VimeoVideo.playButton.onclick = VimeoVideo.play;
          }
        },

        connectApi: function() {
          const vimeoApiScript = document.createElement('script');
          vimeoApiScript.setAttribute('src','https://player.vimeo.com/api/player.js');
          document.head.appendChild(vimeoApiScript);
        },

        play: function() {
          VimeoVideo.playButton.style.display = "none";
          VimeoVideo.player.play();
        }
      }

      VimeoVideo.init();
  }
}
window.isYoutubeAPILoaded = false;

function onYouTubeIframeAPIReady() {
	ProductVideo.loadVideos(ProductVideo.hosts.youtube);
	window.isYoutubeAPILoaded = true;
}

var ProductVideo = (function() {
	var videos = {};

	var hosts = {
		html5: 'html5',
		youtube: 'youtube'
	};

	var selectors = {
		productMediaWrapper: '[data-product-single-media-wrapper]'
	};

	var attributes = {
		enableVideoLooping: 'enable-video-looping',
		videoId: 'video-id',
		mediaId: 'media-id'
	};

	function init(videoContainer, sectionId) {
		if (!videoContainer.length) {
			return;
		}

		var videoElement = videoContainer.find('iframe, video')[0];
		var mediaId = videoContainer.data('mediaId');

		if (!videoElement) {
			return;
		}

		videos[mediaId] = {
			mediaId: mediaId,
			sectionId: sectionId,
			host: hostFromVideoElement(videoElement),
			container: videoContainer,
			element: videoElement,
			ready: function() {
				createPlayer(this);
			}
		};

		var video = videos[mediaId];

		switch (video.host) {
			case hosts.html5:
				window.Shopify.loadFeatures([
					{
						name: 'video-ui',
						version: '1.0',
						onLoad: setupPlyrVideos
					}
				]);
				LibraryLoader.load('plyrShopifyStyles');
				break;
			case hosts.youtube:
				if ( window.isYoutubeAPILoaded ) {
					ProductVideo.loadVideos(ProductVideo.hosts.youtube);
				} else {
					LibraryLoader.load('youtubeSdk');
				}
				break;
		}
	}

	function setupPlyrVideos(errors) {
		if (errors) {
			fallbackToNativeVideo();
			return;
		}

		loadVideos(hosts.html5);
	}

	function createPlayer(video) {
		if (video.player) {
			return;
		}

		var productMediaWrapper = video.container,
			enableLooping = productMediaWrapper.data(attributes.enableVideoLooping),
			mediaId = productMediaWrapper.data(attributes.mediaId);

		switch (video.host) {
			case hosts.html5:
				// eslint-disable-next-line no-undef
				video.player = new Shopify.Plyr(video.element, {
					loop: { active: enableLooping },
					focusOnPlay: true,
                  	controls: ['play-large']
				});

				video.player.on( 'play', function() {
					Product.pauseOtherMedia( mediaId );
				});
				break;
			case hosts.youtube:
				var videoId = productMediaWrapper.data(attributes.videoId);
				video.player = new YT.Player(video.element, {
					videoId: videoId,
					events: {
						// onReady: function(event) {},
						onStateChange: function(event) {
							if (event.data === 0 && enableLooping) event.target.seekTo(0);
							if (event.data === 1 ) Product.pauseOtherMedia( mediaId );
						}
					}
				});
				break;
		}

		productMediaWrapper.on('mediaHidden xrLaunch', function( e ) {
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.pause();
			}

			if (video.host === hosts.youtube && video.player.pauseVideo) {
				video.player.pauseVideo();
			}
		});

		productMediaWrapper.on('mediaVisible', function( e ) {
			if (Helpers.isTouch()) return;
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.play();
			}

			if (video.host === hosts.youtube && video.player.playVideo) {
				video.player.playVideo();
			}
		});
	}

	function hostFromVideoElement(video) {
		if (video.tagName === 'VIDEO') {
			return hosts.html5;
		}

		if (video.tagName === 'IFRAME') {
			if (
				/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
					video.src
				)
			) {
				return hosts.youtube;
			}
		}
		return null;
	}

	function loadVideos(host) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];
				if (video.host === host) {
					video.ready();
				}
			}
		}
	}

	function fallbackToNativeVideo() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.nativeVideo) continue;

				if (video.host === hosts.html5) {
					video.element.setAttribute('controls', 'controls');
					video.nativeVideo = true;
				}
			}
		}
	}

	function removeSectionVideos(sectionId) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.sectionId === sectionId) {
					if (video.player) video.player.destroy();
					delete videos[key];
				}
			}
		}
	}

	return {
		init: init,
		hosts: hosts,
		loadVideos: loadVideos,
		removeSectionVideos: removeSectionVideos
	};
})();

var RelatedProducts = {
	init: function() {
		var $container = $( '[data-section-type="related-products"]' );
		var sectionId = $container.attr('data-section-id');
		var productId = $container.data('product-id');
		var limit = $container.data('limit');
		var requestUrl = '/recommendations/products?section_id=' + sectionId + '&limit=' + limit + '&product_id=' + productId;
		var imageSize = $container.data( 'image-size' );

		$.get(requestUrl)
			.done(function(data) {
				var products = $( data ).find( '[data-section-type="related-products"]' ).html();
				$container.hide().html( products ).slideDown( 'slow' );

				var $image = $container.find( '.collectionBlock-image' );

				Site.animations.animateAll();
				Site.onPriceAdded();
				Site.initReviews();
		});
	}
}

var Reqs = {
	throttle: function(fn, threshhold, scope) {
		threshhold || (threshhold = 250);

		var last,
			deferTimer;

		return function () {
			var context = scope || this;

			var now = +new Date,
				args = arguments;

			if (last && now < last + threshhold) {
				// hold on to it
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function () {
					last = now;
					fn.apply(context, args);
				}, threshhold);
			} else {
				last = now;
				fn.apply(context, args);
			}
		}
	},
	debounce: function(fn, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) fn.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) fn.apply(context, args);
		};
	},
	zoom: function() {
		/*!
			Zoom 1.7.20
			license: MIT
			http://www.jacklmoore.com/zoom
		*/
		(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,r,a,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(a=c,r=u):(a=d.outerWidth(),r=d.outerHeight()),m=(e.width-c)/a,l=(e.height-u)/r,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,r),0),t=Math.max(Math.min(t,a),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),r=document.createElement("img"),a=o(r),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,r.onload=null,a.remove()}.bind(this,i.style.position,i.style.overflow)),r.onload=function(){function t(t){f.init(),f.move(t),a.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(r):!1)}function n(){a.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(r):!1)}var f=o.zoom(i,u,r,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(r)},r.setAttribute("role","presentation"),r.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
	},
	lightbox: function() {
		/*! Magnific Popup - v1.1.0 - 2016-02-20
		* http://dimsemenov.com/plugins/magnific-popup/
		* Copyright (c) 2016 Dmitry Semenov; */
		!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});
	},
	popup: function() {
		/*
			A simple jQuery modal (http://github.com/kylefox/jquery-modal)
			Version 0.6.1
		*/
		!function(o){var t=null;o.modal=function(e,i){o.modal.close();var s,l;if(this.$body=o("body"),this.options=o.extend({},o.modal.defaults,i),this.options.doFade=!isNaN(parseInt(this.options.fadeDuration,10)),e.is("a"))if(l=e.attr("href"),/^#/.test(l)){if(this.$elm=o(l),1!==this.$elm.length)return null;this.$body.append(this.$elm),this.open()}else this.$elm=o("<div>"),this.$body.append(this.$elm),s=function(o,t){t.elm.remove()},this.showSpinner(),e.trigger(o.modal.AJAX_SEND),o.get(l).done(function(i){t&&(e.trigger(o.modal.AJAX_SUCCESS),t.$elm.empty().append(i).on(o.modal.CLOSE,s),t.hideSpinner(),t.open(),e.trigger(o.modal.AJAX_COMPLETE))}).fail(function(){e.trigger(o.modal.AJAX_FAIL),t.hideSpinner(),e.trigger(o.modal.AJAX_COMPLETE)});else this.$elm=e,this.$body.append(this.$elm),this.open()},o.modal.prototype={constructor:o.modal,open:function(){var t=this;this.options.doFade?(this.block(),setTimeout(function(){t.show()},this.options.fadeDuration*this.options.fadeDelay)):(this.block(),this.show()),this.options.escapeClose&&o(document).on("keydown.modal",function(t){27==t.which&&o.modal.close()}),this.options.clickClose&&this.blocker.click(function(t){t.target==this&&o.modal.close()})},close:function(){this.unblock(),this.hide(),o(document).off("keydown.modal")},block:function(){this.$elm.trigger(o.modal.BEFORE_BLOCK,[this._ctx()]),this.blocker=o('<div class="jquery-modal blocker"></div>'),this.$body.css("overflow","hidden"),this.$body.append(this.blocker),this.options.doFade&&this.blocker.css("opacity",0).animate({opacity:1},this.options.fadeDuration),this.$elm.trigger(o.modal.BLOCK,[this._ctx()])},unblock:function(){if(this.options.doFade){var o=this;this.blocker.fadeOut(this.options.fadeDuration,function(){o.blocker.children().appendTo(o.$body),o.blocker.remove(),o.$body.css("overflow","")})}else this.blocker.children().appendTo(this.$body),this.blocker.remove(),this.$body.css("overflow","")},show:function(){this.$elm.trigger(o.modal.BEFORE_OPEN,[this._ctx()]),this.options.showClose&&(this.closeButton=o('<a href="#close-modal" rel="modal:close" class="close-modal '+this.options.closeClass+'">'+this.options.closeText+"</a>"),this.$elm.append(this.closeButton)),this.$elm.addClass(this.options.modalClass+" current"),this.$elm.appendTo(this.blocker),this.options.doFade?this.$elm.css("opacity",0).show().animate({opacity:1},this.options.fadeDuration):this.$elm.show(),this.$elm.trigger(o.modal.OPEN,[this._ctx()])},hide:function(){this.$elm.trigger(o.modal.BEFORE_CLOSE,[this._ctx()]),this.closeButton&&this.closeButton.remove(),this.$elm.removeClass("current");var t=this;this.options.doFade?this.$elm.fadeOut(this.options.fadeDuration,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}):this.$elm.hide(0,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}),this.$elm.trigger(o.modal.CLOSE,[this._ctx()])},showSpinner:function(){this.options.showSpinner&&(this.spinner=this.spinner||o('<div class="'+this.options.modalClass+'-spinner"></div>').append(this.options.spinnerHtml),this.$body.append(this.spinner),this.spinner.show())},hideSpinner:function(){this.spinner&&this.spinner.remove()},_ctx:function(){return{elm:this.$elm,blocker:this.blocker,options:this.options}}},o.modal.close=function(o){if(t){o&&o.preventDefault(),t.close();var e=t.$elm;return t=null,e}},o.modal.isActive=function(){return t?!0:!1},o.modal.defaults={escapeClose:!0,clickClose:!0,closeText:"",closeClass:"",modalClass:"modal",spinnerHtml:null,showSpinner:!0,showClose:!0,fadeDuration:null,fadeDelay:1},o.modal.BEFORE_BLOCK="modal:before-block",o.modal.BLOCK="modal:block",o.modal.BEFORE_OPEN="modal:before-open",o.modal.OPEN="modal:open",o.modal.BEFORE_CLOSE="modal:before-close",o.modal.CLOSE="modal:close",o.modal.AFTER_CLOSE="modal:after-close",o.modal.AJAX_SEND="modal:ajax:send",o.modal.AJAX_SUCCESS="modal:ajax:success",o.modal.AJAX_FAIL="modal:ajax:fail",o.modal.AJAX_COMPLETE="modal:ajax:complete",o.fn.modal=function(e){return 1===this.length&&(t=new o.modal(this,e)),this},o(document).on("click.modal",'a[rel="modal:close"]',o.modal.close),o(document).on("click.modal",'a[rel="modal:open"]',function(t){t.preventDefault(),o(this).modal()})}(jQuery);
	},
	cookie: function() {
		/*!
		 * JavaScript Cookie v2.1.0
		 * https://github.com/js-cookie/js-cookie
		 *
		 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
		 * Released under the MIT license
		 */

		!function(e){if("function"==typeof define&&define.amd)define(e);else if("object"==typeof exports)module.exports=e();else{var n=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=n,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(t){function o(n,r,i){var c;if(arguments.length>1){if(i=e({path:"/"},o.defaults,i),"number"==typeof i.expires){var s=new Date;s.setMilliseconds(s.getMilliseconds()+864e5*i.expires),i.expires=s}try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(a){}return r=t.write?t.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape),document.cookie=[n,"=",r,i.expires&&"; expires="+i.expires.toUTCString(),i.path&&"; path="+i.path,i.domain&&"; domain="+i.domain,i.secure?"; secure":""].join("")}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var f=p[u].split("="),l=f[0].replace(d,decodeURIComponent),m=f.slice(1).join("=");'"'===m.charAt(0)&&(m=m.slice(1,-1));try{if(m=t.read?t.read(m,l):t(m,l)||m.replace(d,decodeURIComponent),this.json)try{m=JSON.parse(m)}catch(a){}if(n===l){c=m;break}n||(c[l]=m)}catch(a){}}return c}return o.get=o.set=o,o.getJSON=function(){return o.apply({json:!0},[].slice.call(arguments))},o.defaults={},o.remove=function(n,t){o(n,"",e(t,{expires:-1}))},o.withConverter=n,o}return n(function(){})});
	}
}

var Gmap = {
	init: function( ) {

		$("div[data-section-type='map']").each( function () {

			var target = $(this);
			var key = $(target).data('key');

			$.getScript(
				  'https://maps.googleapis.com/maps/api/js?key=' + key
				).then(function() {
				  createMap(target);
			});

			function createMap(container){
			  var style = $(container).data('style');
			  var zoom = $(container).data('zoom');
			  var id = $(container).data('section-id');
			  var address = $(container).data('address');
			  var map = new GMaps({
				  div: '.map--'+id,
				  lat: 37.4439064,
				  lng: -122.1639733,
				  navigationControl: false,
				  mapTypeControl: false,
				  scaleControl: false,
				  draggable: false,
				  zoom: zoom
			  });

				var standard =[];
				var silver =[{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];
				var retro =[{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}];
				var dark =[{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}];
				var night =[{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}];
				var aubergine =[{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}];

				var styles = '';
				if(style == 'standard'){
				  styles = standard;
				} else if (style == 'silver'){
				  styles = silver;
				} else if (style == 'retro'){
				  styles = retro;
				} else if (style == 'dark'){
				  styles = dark;
				} else if (style == 'night'){
				  styles = night;
				} else {
				  styles = aubergine;
				}

				map.addStyle({
					styledMapName:"Styled Map",
					styles: styles,
					mapTypeId: "map_style"
				});

				map.setStyle("map_style");
			  GMaps.geocode({
				address: address,
				callback: function(results, status) {
				  if (status == 'OK') {
					var latlng = results[0].geometry.location;
					map.setCenter(latlng.lat(), latlng.lng());
					map.addMarker({
					  lat: latlng.lat(),
					  lng: latlng.lng()
					});
				  }
				}
			  });
			}

		});
	}
}

var Popup = {
	init: function() {
		var self = this;
		var $popup = $('#popup');
		var popupEnabled = $popup.data('enabled');
		var popupTimeout = this.popupTimeout = 0;

		if (popupEnabled) {
			var testMode = $popup.data('testmode');
			var modalDelay = parseInt($popup.data('delay')) * 1000; // Convert from ms to seconds
			var reappearTime = parseInt($popup.data('reappear_time')) * 1000; // Convert from ms to seconds

			// enquire.register("screen and (min-width:320px)", function() {
			// 	Reqs.popup();
			// 	Reqs.cookie();
			//
			// 	if (testMode) {
			// 		self.show($popup, modalDelay, testMode);
			// 	} else {
			// 		//If cookie doesn't exist or it's expired
			// 		if (Cookies.get('newsletter_delay') === undefined || reappearTime == 0){
			// 			self.show($popup, modalDelay, testMode);
			// 			self.createCookie(reappearTime);
			// 		}
			// 	}
			//
			// 	$.modal.defaults = {
			// 		escapeClose: true,      // Allows the user to close the modal by pressing `ESC`
			// 		clickClose: true,       // Allows the user to close the modal by clicking the overlay
			// 		closeText: " ",     // Text content for the close <a> tag.
			// 		closeClass: 'icon-close',         // Add additional class(es) to the close <a> tag.
			// 		showClose: true,        // Shows a (X) icon/link in the top-right corner
			// 		modalClass: "modal",    // CSS class added to the element being displayed in the modal.
			// 		spinnerHtml: null,      // HTML appended to the default spinner during AJAX requests.
			// 		showSpinner: true,      // Enable/disable the default spinner during AJAX requests.
			// 		fadeDuration: 250,     // Number of milliseconds the fade transition takes (null means no transition)
			// 		fadeDelay: .5          // Point during the overlay's fade-in that the modal begins to fade in (.5 = 50%, 1.5 = 150%, etc.)
			// 	};
			// });

			$( window ).on( 'resize', Reqs.debounce( function() {
				var windowWidth = $( window ).width();
				var hasPopup = $( '.jquery-modal' ).length;

				// Hide popup on mobile if visible
				if ( windowWidth < 320 && hasPopup ) {
					Popup.hide();
				}
			}, 100 ));
		}
	},
	show: function($popup, modalDelay, testMode){
		var self = this;

		//Only show if it hasn't already been shown during that browser session
		if (sessionStorage.name != "shown" && $('html').hasClass('lt-ie9') == false){
			this.popupTimeout = setTimeout(function() {
				$popup.modal();
				$popup.css('display','inline-block');
			}, modalDelay);

			// Safari Private Browsing Mode shiv
			if (typeof localStorage === 'object') {
				try {
					localStorage.setItem('localStorage', 1);
					localStorage.removeItem('localStorage');
					sessionStorage.name = "shown";
				} catch (e) {
					Storage.prototype._setItem = Storage.prototype.setItem;
					Storage.prototype.setItem = function() {};
				}
			}
		} else if (testMode) {
			this.popupTimeout = setTimeout(function() {
				$popup.modal();
				$popup.css('display','inline-block');
			}, modalDelay);
		}
	},
	hide: function() {
		clearTimeout( this.popupTimeout );
		if ( $.modal != undefined ) {
			$.modal.close();
		}
	},
	createCookie: function(reappearTime){
		if (reappearTime != 0){
			Cookies.set('newsletter_delay', 'value', { expires: reappearTime });
		}
	}
}

var Password = {
	init: function() {
		var $targets = $('.password-signup, .password-login');

		$targets.each( function(){
			var $el = $(this);
			if ( $el.find('div.errors').length ) {
				$el.find('input.password, input.email').select();
			}
		});
	}
}

var Login = {
	init: function() {
		this.bind();

		if (window.location.hash == '#recover') {
			this.recover.show();
		} else {
			this.recover.hide();
		}
	},

	bind: function(){
		$('.js-recoverToggle').on('click', Login.recover.show);
		$('.js-recoverCancel').on('click', Login.recover.hide);
	},

	recover: {
		show: function(e){
			$('.js-loginForm').hide();
			$('.js-recoverForm').show();
			window.location.hash = '#recover';
			return false;
		},
		hide: function(e){
			$('.js-loginForm').show();
			$('.js-recoverForm').hide();
			window.location.hash = '';
			return false;
		}
	}
}


var Addresses = {
	init: function(){
		// Initialize observers on address selectors
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});

		// Setup province selector on each customer address
		

		// Modified contents of customer_area.js (global asset)
		Shopify.CustomerAddress = {
			toggleForm: function(id) {
				var editEl = document.getElementById('EditAddress_'+id);
				editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
				return false;
			},

			toggleNewForm: function() {
				var el = document.getElementById('AddAddress'),
					toggle = document.getElementById('js-addAddress');
				el.style.display = el.style.display == 'none' ? '' : 'none';
				toggle.style.display = toggle.style.display == 'inline-block' ? 'none' : 'inline-block';
				return false;
			},

			destroy: function(id, confirm_msg) {
				if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
					Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
				}
			}
		}
	}
}

// iOS smooth scrolling fix
var FlickitySmoothScrolling = function( slider ) {
  $(slider).on( 'dragStart.flickity', function( event, pointer ) {
	document.ontouchmove = function (e) {
	  e.preventDefault();
	}
  });
  $(slider).on( 'dragEnd.flickity', function( event, pointer ) {
	document.ontouchmove = function (e) {
	  return true;
	}
  });
}

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */
var slate = {}
slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	  results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
	TAB: 9,
	ENTER: 13,
	ESCAPE: 27,
	LEFTARROW: 37,
	RIGHTARROW: 39
  }
};

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
	var focusClass = 'js-focus-hidden';

	$element
	  .first()
	  .attr('tabIndex', '-1')
	  .focus()
	  .addClass(focusClass)
	  .one('blur', callback);

	function callback() {
	  $element
		.first()
		.removeClass(focusClass)
		.removeAttr('tabindex');
	}
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
	var hash = window.location.hash;

	// is there a hash in the url? is it an element on the page?
	if (hash && document.getElementById(hash.slice(1))) {
	  this.pageLinkFocus($(hash));
	}
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
	$('a[href*=#]').on(
	  'click',
	  function(evt) {
		this.pageLinkFocus($(evt.currentTarget.hash));
	  }.bind(this)
	);
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
	var eventsName = {
	  focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
	  focusout: options.namespace
		? 'focusout.' + options.namespace
		: 'focusout',
	  keydown: options.namespace
		? 'keydown.' + options.namespace
		: 'keydown.handleFocus'
	};

	/**
	 * Get every possible visible focusable element
	 */
	var $focusableElements = options.$container.find(
	  $(
		'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
	  ).filter(':visible')
	);
	var firstFocusable = $focusableElements[0];
	var lastFocusable = $focusableElements[$focusableElements.length - 1];

	if (!options.$elementToFocus) {
	  options.$elementToFocus = options.$container;
	}

	function _manageFocus(evt) {
	  if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

	  /**
	   * On the last focusable element and tab forward,
	   * focus the first element.
	   */
	  if (evt.target === lastFocusable && !evt.shiftKey) {
		evt.preventDefault();
		firstFocusable.focus();
	  }
	  /**
	   * On the first focusable element and tab backward,
	   * focus the last element.
	   */
	  if (evt.target === firstFocusable && evt.shiftKey) {
		evt.preventDefault();
		lastFocusable.focus();
	  }
	}

	options.$container.attr('tabindex', '-1');
	options.$elementToFocus.focus();

	$(document).off('focusin');

	$(document).on(eventsName.focusout, function() {
	  $(document).off(eventsName.keydown);
	});

	$(document).on(eventsName.focusin, function(evt) {
	  if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

	  $(document).on(eventsName.keydown, function(evt) {
		_manageFocus(evt);
	  });
	});
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
	var eventName = options.namespace
	  ? 'focusin.' + options.namespace
	  : 'focusin';

	if (options.$container && options.$container.length) {
	  options.$container.removeAttr('tabindex');
	}

	$(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
	var body = document.querySelector('body');

	var idSelectors = {
	  newWindow: 'a11y-new-window-message',
	  external: 'a11y-external-message',
	  newWindowExternal: 'a11y-new-window-external-message'
	};

	if (options.$links === undefined || !options.$links.jquery) {
	  options.$links = $('a[href]:not([aria-describedby])');
	}

	function generateHTML(customMessages) {
	  if (typeof customMessages !== 'object') {
		customMessages = {};
	  }

	  var messages = $.extend(
		{
		  newWindow: 'Opens in a new window.',
		  external: 'Opens external website.',
		  newWindowExternal: 'Opens external website in a new window.'
		},
		customMessages
	  );

	  var container = document.createElement('ul');
	  var htmlMessages = '';

	  for (var message in messages) {
		htmlMessages +=
		  '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
	  }

	  container.setAttribute('hidden', true);
	  container.innerHTML = htmlMessages;

	  body.appendChild(container);
	}

	function _externalSite($link) {
	  var hostname = window.location.hostname;

	  return $link[0].hostname !== hostname;
	}

	$.each(options.$links, function() {
	  var $link = $(this);
	  var target = $link.attr('target');
	  var rel = $link.attr('rel');
	  var isExternal = _externalSite($link);
	  var isTargetBlank = target === '_blank';

	  if (isExternal) {
		$link.attr('aria-describedby', idSelectors.external);
	  }
	  if (isTargetBlank) {
		if (rel === undefined || rel.indexOf('noopener') === -1) {
		  $link.attr('rel', function(i, val) {
			var relValue = val === undefined ? '' : val + ' ';
			return relValue + 'noopener';
		  });
		}
		$link.attr('aria-describedby', idSelectors.newWindow);
	  }
	  if (isExternal && isTargetBlank) {
		$link.attr('aria-describedby', idSelectors.newWindowExternal);
	  }
	});

	generateHTML(options.messages);
  }
};



// });



// Bamboo

// Object for handle dynamic collection section
var BambooDynamicCollections = {
  sections: {},

  init: function($carousel, carouselType) {
    var dataset = $carousel.closest('.js-collection-grid').data();

    if (this.sections[dataset.sectionId]) {
      this.sections[dataset.sectionId].$carousel = $carousel;
      this.sections[dataset.sectionId].carouselType = carouselType;

      return;
    }

    var countPreloadedProducts = dataset.count_preloaded_products;
    var listProducts = dataset.listProducts;

    var products = [];

    listProducts.map((oneProduct, i) => {
      products.push({
        handle: oneProduct,
        loaded: i < countPreloadedProducts,
        loading: false,
      });
    });

    this.sections[dataset.sectionId] = {
      products,
      countPreloadedProducts,
      nextIndexToLoad: countPreloadedProducts,
      $carousel,
      carouselType,
    }
  },

  changeSlide: function(event, index, element, carouselSlider) {
  	const el = event  ? event.target : element;
    var sectionId = el.dataset.sectionId;
    var collectionHandle = el.dataset.collectionHandle;
    var collectionTitle = el.dataset.collectionTitle;

    if (this.sections[sectionId].nextIndexToLoad >= this.sections[sectionId].products.length) {
      return;
    }

    var currentIndexToLoad = this.sections[sectionId].nextIndexToLoad;

    if (this.sections[sectionId].carouselType === 'flickity') {
      if (
        index < (this.sections[sectionId].nextIndexToLoad - this.sections[sectionId].countPreloadedProducts)
        || this.sections[sectionId].products[currentIndexToLoad].loaded == true
      ) {
        return;
      }


      this.sections[sectionId].products[currentIndexToLoad].loading = true;

      this.sections[sectionId].nextIndexToLoad++;

      this.loadSlide({
        sectionId,
        currentIndexToLoad,
        carouselType: this.sections[sectionId].carouselType,
        collectionHandle,
        collectionTitle,
      }, carouselSlider);
    }

    if (this.sections[sectionId].carouselType === 'slick') {
      for (var i = 0; i < 6; i++) {
        if (this.sections[sectionId].nextIndexToLoad >= this.sections[sectionId].products.length) {
          return;
        }

        currentIndexToLoad = this.sections[sectionId].nextIndexToLoad;


        if (this.sections[sectionId].products[index + (3 * 2) + 1] && this.sections[sectionId].products[index + (3 * 2) + 1].loaded == true) {
          continue;
        }

        this.sections[sectionId].products[currentIndexToLoad].loading = true;

        this.sections[sectionId].nextIndexToLoad++;

        this.loadSlide({
          sectionId,
          currentIndexToLoad,
          carouselType: this.sections[sectionId].carouselType,
          collectionHandle,
          collectionTitle,
        }, carouselSlider);
      }
    }
  },

  buildProductGridItem: function(product, params) {
        var source = $('#ProductSlideTemplate').html();

        var template = Handlebars.compile(source);

        let item_secondImage;
        let item_condHoverImg;
        let item_onSale;
        let item_soldOut;

    	if (params.sourceType && params.sourceType === 'storefrontApi') {
          item_secondImage = (product.node.media.edges[1] && false)?'has-second-image':'';
          item_condHoverImg = (product.node.media.edges[1].node.previewImage.src != '' && false);
          item_onSale = parseFloat(product.node.compareAtPriceRange.maxVariantPrice.amount) > parseFloat(product.node.priceRange.minVariantPrice.amount);
          item_soldOut = !product.node.availableForSale;
        } else {
          item_secondImage = (product.media[1].preview_image && false)?'has-second-image':'';
          item_condHoverImg = (product.media[1].preview_image != '' && false);
          item_onSale = product.compare_at_price > product.price;
          item_soldOut = !product.available;
        }


        let is_have_label_new = '';
        let is_have_label_coming_soon = '';
    	let is_have_label_pre_order = '';
    	let is_have_label_responsible = '';
		let tags;

    	if (params.sourceType && params.sourceType === 'storefrontApi') {
          tags = product.node.tags;
        } else {
          tags = product.tags;
        }

    	for (var [key, value] of Object.entries(tags)) {
          if (value === 'Новинки') {is_have_label_new = true;}
          if (value === 'Скоро в продаже') {is_have_label_coming_soon = true;}
        }

        var labels = '';
        if (is_have_label_new) {
          	labels = "New";
        }
        else if (is_have_label_pre_order) {
			labels = "Pre-order";
        }
        else if (is_have_label_coming_soon) {
			labels = "Coming soon";
        }
        else if (is_have_label_new) {
			labels = "New";
        }
        else if (is_have_label_responsible) {
          	labels = "Responsible";
        }


        var statusLowerPrice = '';
        if(item_soldOut){
          if(is_have_label_responsible){
            statusLowerPrice = "Coming Soon&ensp;Responsible"}
          else{
            statusLowerPrice = "Coming Soon";
          }
        }
        else if(item_onSale){
          if(is_have_label_responsible){
            statusLowerPrice = "Sale&ensp;Responsible"}
          else{
            statusLowerPrice = "Sale";
          }

        }
        else if(item_onSale && item_soldOut){
          if(is_have_label_responsible){
            statusLowerPrice = "Coming Soon&ensp;Responsible"}
          else{
            statusLowerPrice = "Coming Soon";
          }
        }


        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;


        let imageWidthDelimiter = params.productsColumns;

        if (windowWidth <= 768) { // Mobile view breackpoint
        	imageWidthDelimiter = 1;
        }

        var productImageWidth = Math.round(windowWidth / imageWidthDelimiter);


        var imageSizeString = productImageWidth.toString() + "x";

        const item = {
          onSale: item_onSale,
          soldOut: item_soldOut,
          productLabels: labels,
          settingsPriceHover: false,
          settingsShowQuickView: false,
          classShowSecondImage: item_secondImage,
          labelLowerPrice: statusLowerPrice,
          conditionsSale_or_SoldOut: item_onSale || item_soldOut,
          conditionsHoverImage: item_condHoverImg,
          bambooWishlistElementId: params.bambooWishlistElementId,
          mainBlockStyle: params.mainBlockStyle,
          bambooGridItemElementId: params.bambooGridItemElementId,
          collectionTitle: params.collectionTitle,
          position: params.currentIndexToLoad + 1,
		  color: productMetafields[params.collectionTitle] ? product.handle ? productMetafields[params.collectionTitle][product.handle].color : productMetafields[params.collectionTitle][product.node.handle].color : null,
		  colorsGroup: productMetafields[params.collectionTitle] ? product.handle ? productMetafields[params.collectionTitle][product.handle].colorsGroup : productMetafields[params.collectionTitle][product.node.handle].colorsGroup : [],
        };

        let featuredImageIndex = 0;
        let minRatioForThinImage;
        let maxRatioForThinImage;

        if ('0.6' !== 'none' && settings.pageType === 'index') {
        	minRatioForThinImage = parseFloat('0.6') - 0.1;
            maxRatioForThinImage = parseFloat('0.6') + 0.1;
        }

        if (params.sourceType && params.sourceType === 'storefrontApi') {

            if ('0.6' !== 'none' && settings.pageType === 'index') {
                const thirdImageAspectRatio = product.node.media.edges[2].node.previewImage.width / product.node.media.edges[2].node.previewImage.height;

				if (thirdImageAspectRatio > minRatioForThinImage && thirdImageAspectRatio < maxRatioForThinImage) {
              		featuredImageIndex = 2;
            	}
            }

            item.productId = atob(product.node.id).replace('gid://shopify/Product/', '');
            item.productAvailable = product.node.availableForSale;
            item.productTitle = product.node.title;
            item.productHandle = product.node.handle;
            item.productPreview = Shopify.Image.getSizedImageUrl(product.node.media.edges[featuredImageIndex].node.previewImage.src, imageSizeString);
            if (product.node.media[1]?.src) {
              item.productPreview1 = Shopify.Image.getSizedImageUrl(product.media[1].src, imageSizeString);
            }
            item.productAspectratio = product.node.media.edges[featuredImageIndex].node.previewImage.width / product.node.media.edges[featuredImageIndex].node.previewImage.height;
            item.productTitleAlt = product.node.media.edges[featuredImageIndex].node.previewImage.altText;
            item.productPriceVaries = product.node.priceRange.minVariantPrice.amount != product.node.priceRange.maxVariantPrice.amount;
          	item.productPriceMin = Shopify.formatMoney(Number(product.node.priceRange.minVariantPrice.amount * 100), Shopify.money_format_duplicate);
            item.productCompareAtPrice = Shopify.formatMoney(Number(product.node.compareAtPriceRange.maxVariantPrice.amount * 100), Shopify.money_format_duplicate);
            item.productPrice = Shopify.formatMoney(Number(product.node.priceRange.minVariantPrice.amount * 100), Shopify.money_format_duplicate);
            item.productVendor = product.node.vendor;
            item.productPriceWithoutCurrency = product.node.priceRange.minVariantPrice.amount;

            if (params.collectionHandle) {
              	const productUrl = new URL(product.node.onlineStoreUrl);
              	console.log(product)

              	item.productUrl = `/collections/${params.collectionHandle}${productUrl.pathname}`
            } else {
              	item.productUrl = product.node.onlineStoreUrl;
            }
        } else {
            if (
              	'0.6' !== 'none'
                && settings.pageType === 'index'
                && product.media[2].aspect_ratio > minRatioForThinImage
              	&& product.media[2].aspect_ratio < maxRatioForThinImage
            ) {
                featuredImageIndex = 2;
            }

            item.productId = product.id;
            item.productAvailable = product.available;
            item.productTitle = product.title;
            item.productHandle = product.handle;
            item.productPreview = Shopify.Image.getSizedImageUrl(product.media[featuredImageIndex].src, imageSizeString);
            if (product.media[1]?.src) {
              item.productPreview1 = Shopify.Image.getSizedImageUrl(product.media[1].src, imageSizeString);
            }
            item.productAspectratio = product.media[featuredImageIndex].aspect_ratio;
            item.productTitleAlt = product.media[featuredImageIndex].alt;
            item.productPriceVaries = product.price_varies;
            item.productPriceMin = Shopify.formatMoney(product.price_min, Shopify.money_format_duplicate);
            item.productCompareAtPrice = Shopify.formatMoney(product.compare_at_price, Shopify.money_format_duplicate);
            item.productPrice = Shopify.formatMoney(product.price, Shopify.money_format_duplicate);
            item.productVendor = product.vendor;
            item.productPriceWithoutCurrency = product.price / 100;

            if (params.collectionHandle) {
              	item.productUrl = `/collections/${params.collectionHandle}${product.url}`;
            } else {
                item.productUrl = product.url;
			}

        }

      return template(item);
  },

  loadSlide: async function(data, carouselSlider) {
    Shopify.getProduct(this.sections[data.sectionId].products[data.currentIndexToLoad].handle, function (product, textStatus) {
      BambooDynamicCollections.buildSlide({data, product}, carouselSlider);

      BambooDynamicCollections.sections[data.sectionId].products[data.currentIndexToLoad].loading = false;
      BambooDynamicCollections.sections[data.sectionId].products[data.currentIndexToLoad].loaded = true;
	});
  },

  buildSlide: function(params, carouselSlider) {
    let bambooWishlistElementId;
    let bambooGridItemElementId;

    if (params.sourceType && params.sourceType === 'storefrontApi') {
      	const productId = atob(params.product.node.id).replace('gid://shopify/Product/', '');
		const variantId = atob(params.product.node.variants.edges[0].node.id).replace('gid://shopify/ProductVariant/', '');

      	bambooWishlistElementId = `bamboo-wishlist-${params.data.sectionId}-${productId}-${variantId}`;
        bambooGridItemElementId = `bamboo-grid-item-${params.data.sectionId}-${productId}`;
    } else {
    	bambooWishlistElementId = `bamboo-wishlist-${params.data.sectionId}-${params.product.id}-${params.product.variants[0].id}`;
    	bambooGridItemElementId = `bamboo-grid-item-${params.data.sectionId}-${params.product.id}`;
    }


    const buitTemplate = BambooDynamicCollections.buildProductGridItem(
      params.product,
      {
        bambooWishlistElementId,
        mainBlockStyle: 'width: 100%; display: inline-block;',
        productsColumns: 3,
        sourceType: params.sourceType,
        collectionHandle: params.data.collectionHandle,
        collectionTitle: params.data.collectionTitle,
        currentIndexToLoad: params.data.currentIndexToLoad,
        bambooGridItemElementId,
      }
    );


    if (params.data.carouselType === 'flickity') {
		carouselSlider.append($( buitTemplate ))
      // BambooDynamicCollections.sections[params.data.sectionId].$carousel.flickity( 'append', $( buitTemplate ) );
    }

    if (params.data.carouselType === 'slick') {
      BambooDynamicCollections.sections[params.data.sectionId].$carousel.slick(
        'slickAdd', '<div>' + buitTemplate + '</div>'
      );
    }


    const bambooWishlistParams = {
      htmlElementId: bambooWishlistElementId,
    };

    window.bambooWishlistHelper.addHtmlElement(bambooWishlistParams);
    window.bambooWishlistHelper.initHtmlElement(bambooWishlistParams);

    window.bambooIntersectionObserverHelper.addToObserveById(bambooGridItemElementId);
  },

}

// Helper for handle accordion
var BambooAccordionHelper = {
  init: function() {
    const bambooAccordionWrapper = document.getElementById('bamboo-accordion-footer');

    const bambooAccordionsTitleElements = bambooAccordionWrapper.getElementsByClassName('bamboo-accordion-title');

    Array.prototype.forEach.call(bambooAccordionsTitleElements, oneAccordionTitleEl => {
      oneAccordionTitleEl.onclick = e => {
          if (getElementFromPathByClassName(e, 'bamboo-accordion-body')) {
            return;
          }


          const accordionTitleEl = getElementFromPathByClassName(e, 'bamboo-accordion-title');

          if (accordionTitleEl.classList && Array.prototype.includes.call(accordionTitleEl.classList, 'bamboo-accordion-title')) {
            const accordionBodyEl = Array.prototype.find.call(accordionTitleEl.children, oneEl => {
              if (!oneEl.classList) {
                return false;
              }

              return Array.prototype.includes.call(oneEl.classList, 'bamboo-accordion-body');
            });

            if (Array.prototype.includes.call(accordionBodyEl.classList, 'bamboo-accordion-body-opened')) {
              accordionBodyEl.classList.add('bamboo-accordion-body-closed');
              accordionBodyEl.classList.remove('bamboo-accordion-body-opened');
              accordionTitleEl.classList.remove('active');
            } else {
              const bambooAccordionsBodyElements = bambooAccordionWrapper.getElementsByClassName('bamboo-accordion-body');

              Array.prototype.forEach.call(bambooAccordionsBodyElements, oneAccordionBodyEl => {
                oneAccordionBodyEl.classList.add('bamboo-accordion-body-closed');
                oneAccordionBodyEl.classList.remove('bamboo-accordion-body-opened');
              });


              const bambooAccordionsTitleElements = bambooAccordionWrapper.getElementsByClassName('bamboo-accordion-title');

              Array.prototype.forEach.call(bambooAccordionsTitleElements, oneAccordionTitleEl => {
                oneAccordionTitleEl.classList.remove('active');
              });


              accordionBodyEl.classList.add('bamboo-accordion-body-opened');
              accordionTitleEl.classList.add('active');
              accordionBodyEl.classList.remove('bamboo-accordion-body-closed');
            }

            return;
          }

          return;

          function getElementFromPathByClassName(e, className) {
            if (e.path) {
              return e.path.find(oneEl => {
                if (!oneEl.classList) {
                  return false;
                }

                return Array.prototype.includes.call(oneEl.classList, className);
              });

              return;
            }

            if (e.target.classList && Array.prototype.includes.call(e.target.classList, className)) {
              return e.target;
            } else {
              if (
                e.target.parentElement.classList
                && Array.prototype.includes.call(e.target.parentElement.classList, className)
              ) {
                return e.target.parentElement;
              }

              return;
            }
          };
      };
    });
  }
}

const screenSize = {
  width: 0,
  height: 0,

  init: function() {
    this.changeSizes();
  },

  getHeight: function() {
    return this.height
  },

  getWidth: function() {
    return this.width
  },

  setHeight: function(height) {
    this.height = height;
  },

  setWidth: function(width) {
    this.width = width;
  },

  setCSS: function() {
  	document.documentElement.style.setProperty('--app-height', `${this.height}px`);
  },

  changeSizes() {
    this.setWidth(window.innerWidth);
    this.setHeight(window.innerHeight);
    this.setCSS();
  },


  isMobile: function() {
  	return this.width < 549
  }
}

window.addEventListener('resize', function(){
  	screenSize.changeSizes();

})
screenSize.init()

/* Bamboo. Application "Best Fit - Size Chart".
	With the modal open, stop scrolling the site */
$(document).on('click touchstart', '.scr-open-size-chart', function() {
	$("body").css("overflow","hidden");

    $(".scr-close").on("click", removeBodyOverflow);

    $("body").on("click", function(e) {

      if($("body").is('[style]')) {
          $("body").css("overflow","unset");
      }
    });
});
/* Bamboo. "Best Fit - Size Charts". End */

class Ampersand extends HTMLElement {
	connectedCallback() {
		this.innerHTML = "&";
	}
}

customElements.define('custom-ampersand', Ampersand);

const GiftCard = {
	init: function() {
		this.Variants.init()
		this.Modal.init();
		this.Form.init();
	},
	Variants: {
		element: null,
		selectors: {
			variants: '#js-giftCardVariant .gift-card-variants__item',
		},
		init: function () {
			this.variants = $(this.selectors.variants);

			this.variants.each((_, variant) => {
				$(variant).on("click", (e) => {
					this.changeVariant($(e.target))
				});
			})
		},
		changeVariant: function (variant) {
				const id = variant.attr('data-id')
				const title = variant.attr('data-title')
				Array.from(document.querySelectorAll('.gift-card-variants__item')).forEach((el) => el.classList.remove('gift-card-variants__item_selected'));
				variant.addClass('gift-card-variants__item_selected')
				Product.changeVariant(id, title)
		},
	},
	Modal: {
		modal: null,
		openButton: null,
		closeButton: null,
		selectors: {
			modal: '#js-giftCardModal',
			openButton: "#js-sendGiftCardButton",
			closeButton: '#js-giftCardModalClose',
		},
		init: function() {
			this.initElements();

			if (this.modal.length) {
				this.openButton.click(() => this.open());
				this.closeButton.click(() => this.close());
			}
		},
		open: function () {
			this.modal.addClass('visible');
			$('body').addClass('body-lock');

			GiftCard.Form.fields.forEach(item => {
				if (item.required || item.type === 'textarea') {
					GiftCard.Form.validate(item)
				}
			});
		},
		close: function() {
			this.modal.removeClass('visible');
			$('body').removeClass('body-lock');
		},
		initElements: function () {
			this.modal = $(this.selectors.modal);
			this.openButton = $(this.selectors.openButton);
			this.closeButton = $(this.selectors.closeButton)
		},
	},
	Form: {
		form: null,
		submitButton: null,
		selectors: {
			form: '#js-giftCardModalForm',
			submit: '#js-giftCardModalSubmit'
		},
		fields: [
			{type: 'text', name: 'name', validate: false, required: true, value: null},
			{type: 'text', name: 'recipient_name', validate: false, required: true, value: null},
			{type: 'email', name: 'recipient_email', validate: false, required: true, value: null},
			// {type: 'date', name: 'date', validate: false, required: true},
			{type: 'textarea', name: 'message', validate: true, required: false, value: null}
		],
		isValid: false,
		init: function() {
			this.initElements();

			if (this.form.length) {
				this.submitButton.click((e) => this.submit(e))

				this.fields.forEach(item => {
					if (item.required || item.type === 'textarea') {
						this.form.find(`[name=${item.name}]`).keyup(() => this.validate(item))
					}
				});
			}
		},
		submit: function(e) {
			e.preventDefault();
			const properties = this.fields.reduce((prev, cur) => {
				prev[cur.name] = this.form.find(`[name=${cur.name}]`).val()
				return prev;
			}, {})
			Cart.submit($('#AddToCart'), properties, true)
		},
		validate: function(field) {
			const value = this.form.find(`[name=${field.name}]`).val();

			if (field.type === 'email') {
				this.fields = emailRegex.test(String(value).toLowerCase())
					?  this.fields.map(item => item.name === field.name ? {...field, validate: true} : item)
					:  this.fields.map(item => item.name === field.name ? {...field, validate: false} : item);
			} else if (field.type === 'date') {

			} else if (field.type === 'textarea') {
				this.fields = value.length <= 400
					?  this.fields.map(item => item.name === field.name ? {...field, validate: true} : item)
					:  this.fields.map(item => item.name === field.name ? {...field, validate: false} : item);
			} else {
				this.fields = value && value.split(' ').join('').length && value.split(' ').join('').length <= 60
					?  this.fields.map(item => item.name === field.name ? {...field, validate: true} : item)
					:  this.fields.map(item => item.name === field.name ? {...field, validate: false} : item);
			}
			this.isValid = !this.fields.find(item => (item.required || item.type === 'textarea') && !item.validate);
			if (this.isValid) {
				this.submitButton.removeClass('form__submit_disabled')
				this.submitButton.prop('disabled', false)
			} else {
				this.submitButton.addClass('form__submit_disabled')
				this.submitButton.prop('disabled', true)
			}
		},
		initElements: function () {
			this.form = $(this.selectors.form)
			this.submitButton = $(this.selectors.submit)
		}
	}
}

GiftCard.init()

function getQueryParams(qs) {
	qs = qs.split('+').join(' ');

	var params = {},
		tokens,
		re = /[?&]?([^=]+)=([^&]*)/g;

	while (tokens = re.exec(qs)) {
		params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
	}

	return params;
}

const isUserSigned = getQueryParams(document.location.search).signed;

if (isUserSigned) {
	$('body').append('<div class="message">You have been successfully subscribed<br/> to the newsletter</div>')
	$('.message').delay(5000).fadeOut('slow');
}

const contactForm = document.querySelector('.contact-form-container #contact_form')
if (contactForm) {
	contactForm.addEventListener("submit", function(e){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event' : 'UA',
			'eventCategory' : 'lead_email',
			'eventAction' : 'submit',
			'eventLabel' : 'contact_us'
		});
	});
}

window._learnq = window._learnq || [];

let checkoutButtonsElements = document.getElementsByClassName("cart-checkout");

for (var i=0, len=checkoutButtonsElements.length|0; i<len; i=i+1|0) {
	checkoutButtonsElements[i].addEventListener('click',function (){
		_learnq.push(['track', 'Checkout button clicked', {}]);
	});
}

function checkProductInfoHeight() {
	const $productImgScroller = $('.js-productImgScroller')
	// const $productInfo = $('.js-product-info__wrapper')
	const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (windowWidth >= 1024) {
		$productImgScroller.height($('.product-single__media.lazyloaded').innerHeight());

	} else {
		$productImgScroller.height('auto');
	}
}

if ($('.product__description').length) {
	const descriptionArray = $('.product__description').html().split('<h6')
	let result = '';
	if (descriptionArray[0] !== '') {
		result += descriptionArray[0]
	}
	if (descriptionArray.length > 1) {
			result += '<div class="accordion">'
			for (let index = 1; index < descriptionArray.length; index++) {
				const item = descriptionArray[index].substring(descriptionArray[index].indexOf('>') + 1).split('</h6>')
				const title = item[0];
				const content  = item[1]
				if (!title && content && index === 1) {
					result += `<p>${content}</p>`;
					continue;
				}
				result += '<div class="accordion__item">';
				result += `<div class="accordion__title">${title}</div>`
				result += `<div class="accordion__content">${content}</div>`
				result += '</div>'
			}
			result += '</div>'
			$('.product__description').html(result)


		}

}

if ($('.accordion').length) {
	$('.accordion__title').click(function () {
		const $content = $(this).next()
		if ($(this).hasClass('accordion__title_active')) {
			$(this).removeClass('accordion__title_active');
			$content.removeClass('accordion__content_active');
			$content.css('maxHeight', 0)
			$content.css('height', 0)
			setInterval(function () {
				checkProductInfoHeight()
			}, 300);
		} else {
			$(this).addClass('accordion__title_active');
			$content.addClass('accordion__content_active');
			$content.css('maxHeight', $($content).prop('scrollHeight'))
			$content.css('height', $($content).prop('scrollHeight'))
			setInterval(function () {
				checkProductInfoHeight()
			}, 300);
		}
	})
}

function submitFooterSubscriptionForm(email) {
	const encodedEmail = encodeURIComponent(email);
	const data = `form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter&contact%5Bemail%5D=${encodedEmail}`;

	$.ajax( {
		type: 'post',
		url: '/contact',
		dataType: 'text',
		data,
		success: function( response ) {}
	});
}

document.addEventListener("DOMContentLoaded", function() {
	let alertHeight = 0;
	const siteAlert = document.querySelector('.js-siteAlert');

	if (siteAlert) {
		alertHeight = siteAlert.offsetHeight;
	}

	document.documentElement.style.setProperty('--alert-height', alertHeight + 'px');
});

window.debounce = (func, wait) => {
	let timeout;
	return function(...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}

window.getTags = (tags) => {
	const result = [];
	if (tags.includes(TAGS.NEW)) result.push(TAGS.NEW);
	if (tags.includes(TAGS.GI)) result.push(TAGS.GI);
	if (tags.includes(TAGS.PREORDER)) result.push(TAGS.PREORDER);
	if (tags.includes(TAGS.COMING_SOON) && !tags.includes(TAGS.ONLINE_ONLY)) result.push(TAGS.COMING_SOON);
	if (tags.includes(TAGS.RESPONSIBLE)) result.push(TAGS.RESPONSIBLE);
	if (tags.includes(TAGS.EXCLUSIVE_PRICE)) result.push(TAGS.EXCLUSIVE_PRICE);
	if (tags.includes(TAGS.ONLINE_ONLY)) result.push(TAGS.ONLINE_ONLY);
	if (tags.includes(TAGS.COMING_SOON) && !tags.includes(TAGS.ONLINE_ONLY)) {
		result.push(TAGS.COMING_SOON);
	} else if (tags.includes(TAGS.INSTORE)) {
		result.push('In-store only');
	}
	return result;
}
